export default [{
    'applyNo': '2022110500001',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.116887',
    'eventName': '救海龜',
    'id': 0,
    'location': '觀夕平台西北側',
    'organizer': '信義房屋永康區',
    'participateNum': '45',
    'startTime': '11/18/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.116896'
},
{
    'applyNo': '2022103100001',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.116901',
    'eventName': '無尾港"淨"tshing-khì',
    'id': 1,
    'location': '蘇澳鎮大坑罟海灘',
    'organizer': '宜蘭縣立文化國中',
    'participateNum': '50',
    'startTime': '11/25/2022 14:30:00',
    'updated': '2024-05-14 06:50:55.116905'
},
{
    'applyNo': '2022110200003',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.116909',
    'eventName': '「海上與你，相約淨灘」',
    'id': 2,
    'location': '台中清水區1段海岸',
    'organizer': '烏町印製所',
    'participateNum': '6',
    'startTime': '11/26/2022 14:30:00',
    'updated': '2024-05-14 06:50:55.116912'
},
{
    'applyNo': '2022103100006',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.116916',
    'eventName': '新北市-沙崙海水浴場淨灘活動',
    'id': 3,
    'location': '沙崙海水浴場',
    'organizer': '台科大海洋淨灘團gogo',
    'participateNum': '20',
    'startTime': '11/26/2022 10:00:00',
    'updated': '2024-05-14 06:50:55.116919'
},
{
    'applyNo': '2022110100003',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.116923',
    'eventName': '減廢淨灘 我愛地球',
    'id': 4,
    'location': '桃園新屋永安海螺文化園區北側',
    'organizer': '桃園市東勢庄生態發展協會',
    'participateNum': '81',
    'startTime': '11/06/2022 14:30:00',
    'updated': '2024-05-14 06:50:55.116927'
},
{
    'applyNo': '2022110200007',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.116930',
    'eventName': '第11場公開行動',
    'id': 5,
    'location': '大溪十三佛寺',
    'organizer': '海邊的接力賽',
    'participateNum': '10',
    'startTime': '11/22/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.116934'
},
{
    'applyNo': '2022110700013',
    'cityName': '花蓮縣',
    'created': '2024-05-14 06:50:55.116937',
    'eventName': '季節淨灘活動',
    'id': 6,
    'location': '遠雄海洋公園海岸停車場外海灘',
    'organizer': '遠雄海洋公園',
    'participateNum': '100',
    'startTime': '11/08/2022 09:30:00',
    'updated': '2024-05-14 06:50:55.116940'
},
{
    'applyNo': '2022110700012',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.116944',
    'eventName': '伸港海洋生態淨灘',
    'id': 7,
    'location': '伸港生態教育中心',
    'organizer': 'EG淨灘夥伴',
    'participateNum': '20',
    'startTime': '11/12/2022 13:00:00',
    'updated': '2024-05-14 06:50:55.116947'
},
{
    'applyNo': '2022110700001',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.116951',
    'eventName': '環保公益淨灘',
    'id': 8,
    'location': '蚵仔寮海灘',
    'organizer': '高雄市光明慈善文教協會',
    'participateNum': '50',
    'startTime': '12/04/2022 08:00:00',
    'updated': '2024-05-14 06:50:55.116954'
},
{
    'applyNo': '2022110200013',
    'cityName': '雲林縣',
    'created': '2024-05-14 06:50:55.116958',
    'eventName': '雲友似海-愛護海洋從環保做起淨灘活動暨烤肉摸彩晚會',
    'id': 9,
    'location': '雲林縣口湖鄉台子村台興路86號(天台宮)',
    'organizer': '社團法人雲林縣進沿海作業漁船協進會',
    'participateNum': '100',
    'startTime': '11/12/2022 15:30:00',
    'updated': '2024-05-14 06:50:55.116961'
},
{
    'applyNo': '2022111400008',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.116964',
    'eventName': '友善海洋 永續生活',
    'id': 10,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '200',
    'startTime': '12/11/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.116968'
},
{
    'applyNo': '2022111300004',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.116971',
    'eventName': '昇恆昌內湖旗艦店ESG讓地球永續-淨灘活動',
    'id': 11,
    'location': '石門老梅綠石槽海岸',
    'organizer': '昇恆昌內湖旗艦店',
    'participateNum': '80',
    'startTime': '11/27/2022 09:30:00',
    'updated': '2024-05-14 06:50:55.116975'
},
{
    'applyNo': '2022111700002',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.116978',
    'eventName': '【護眾生愛地球】公益淨灘',
    'id': 12,
    'location': '林口大坑站前海岸即「藍色公路海景咖啡館前海岸線」',
    'organizer': '淨心淨灘團',
    'participateNum': '20',
    'startTime': '12/14/2022 08:30:00',
    'updated': '2024-05-14 06:50:55.116981'
},
{
    'applyNo': '2022112000001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.116985',
    'eventName': '臺大社工系社服部淨灘活動',
    'id': 13,
    'location': '淡水',
    'organizer': '臺大社工系社服部',
    'participateNum': '3',
    'startTime': '11/26/2022 10:00:00',
    'updated': '2024-05-14 06:50:55.116988'
},
{
    'applyNo': '2022112100005',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.116992',
    'eventName': '嘿嘿叫之愛地球',
    'id': 14,
    'location': '萬里龜吼海灘(珍如意餐廳旁海灘)',
    'organizer': '陳姿蓉',
    'participateNum': '10',
    'startTime': '12/17/2022 14:00:00',
    'updated': '2024-05-14 06:50:55.116995'
},
{
    'applyNo': '2022111900001',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.116999',
    'eventName': 'Fuhsing Impact淨灘',
    'id': 15,
    'location': '頭城',
    'organizer': 'Fuhsing Impact',
    'participateNum': '10',
    'startTime': '11/26/2022 13:00:00',
    'updated': '2024-05-14 06:50:55.117003'
},
{
    'applyNo': '2022120100005',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117006',
    'eventName': '12月17日(六)不廢青年_淺水灣~六塊厝淨灘',
    'id': 16,
    'location': '集合地點： ✩沙湖路空地 https://goo.gl/maps/csrvyWEkXEHzn7iZ9',
    'organizer': '不廢青年',
    'participateNum': '50',
    'startTime': '12/17/2022 13:00:00',
    'updated': '2024-05-14 06:50:55.117010'
},
{
    'applyNo': '2022112900002',
    'cityName': '臺東縣',
    'created': '2024-05-14 06:50:55.117013',
    'eventName': '淨灘活動',
    'id': 17,
    'location': '海濱公園',
    'organizer': '台中市雷虎教會',
    'participateNum': '10',
    'startTime': '12/10/2022 15:00:00',
    'updated': '2024-05-14 06:50:55.117017'
},
{
    'applyNo': '2022112900004',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117020',
    'eventName': '新北市-沙崙海水浴場-淨灘活動',
    'id': 18,
    'location': '沙崙海水浴場',
    'organizer': '台科大海洋淨灘團',
    'participateNum': '30',
    'startTime': '12/11/2022 14:00:00',
    'updated': '2024-05-14 06:50:55.117023'
},
{
    'applyNo': '2022120200001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117027',
    'eventName': '服務學習',
    'id': 19,
    'location': '八里挖子尾海灘',
    'organizer': '教育部 世新大學新聞人報社',
    'participateNum': '32',
    'startTime': '12/03/2022 15:00:00',
    'updated': '2024-05-14 06:50:55.117030'
},
{
    'applyNo': '2022120600003',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.117034',
    'eventName': '海龜不哭淨灘X聖誕聯誼交換禮物',
    'id': 20,
    'location': '觀音海水浴場',
    'organizer': '海龜不哭',
    'participateNum': '60',
    'startTime': '12/25/2022 13:00:00',
    'updated': '2024-05-14 06:50:55.117037'
},
{
    'applyNo': '2022120800001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117040',
    'eventName': '海灘巡禮',
    'id': 21,
    'location': '嘉寶沙灘',
    'organizer': '石牌玄帝宮志工組',
    'participateNum': '28',
    'startTime': '12/18/2022 08:30:00',
    'updated': '2024-05-14 06:50:55.117044'
},
{
    'applyNo': '2022120900002',
    'cityName': '新竹縣',
    'created': '2024-05-14 06:50:55.117047',
    'eventName': '1/2新年大掃除 竹北鳳山溪河堤淨灘活動',
    'id': 22,
    'location': '竹北鳳山溪河堤，Google地圖座標：https://goo.gl/maps/Fe3zU66RpaU',
    'organizer': '海湧工作室有限公司',
    'participateNum': '300',
    'startTime': '01/02/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.117051'
},
{
    'applyNo': '2022120500005',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.117054',
    'eventName': '搶救海洋大作戰~',
    'id': 23,
    'location': '台中市清水區1段',
    'organizer': '林小佐',
    'participateNum': '2',
    'startTime': '12/19/2022 13:30:00',
    'updated': '2024-05-14 06:50:55.117057'
},
{
    'applyNo': '2022121800001',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.117061',
    'eventName': '第11場公開行動',
    'id': 24,
    'location': '新城溪出海口左側',
    'organizer': '海邊的接力賽',
    'participateNum': '10',
    'startTime': '12/27/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.117064'
},
{
    'applyNo': '2022122200001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117068',
    'eventName': '【護眾生愛地球】公益淨灘',
    'id': 25,
    'location': '林口大坑站前海岸即「藍色公路海景咖啡館前海岸線」',
    'organizer': '淨心淨灘團',
    'participateNum': '30',
    'startTime': '01/11/2023 08:30:00',
    'updated': '2024-05-14 06:50:55.117071'
},
{
    'applyNo': '2023010600001',
    'cityName': '澎湖縣',
    'created': '2024-05-14 06:50:55.117074',
    'eventName': '海上與你，相約淨灘',
    'id': 26,
    'location': '澎湖寵物公園帆船館後方',
    'organizer': '烏町印製所',
    'participateNum': '5',
    'startTime': '01/26/2023 16:00:00',
    'updated': '2024-05-14 06:50:55.117078'
},
{
    'applyNo': '2023011100004',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.117081',
    'eventName': '淨灘',
    'id': 27,
    'location': '漁光島北邊海灘',
    'organizer': '台南淨遊趣',
    'participateNum': '100',
    'startTime': '01/14/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117107'
},
{
    'applyNo': '2023010900002',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.117117',
    'eventName': '雄大淨灘小組第47次活動',
    'id': 28,
    'location': '高雄市梓官區通港路底附近海灘',
    'organizer': '高雄中學75級同學會雄大淨灘小組',
    'participateNum': '15',
    'startTime': '01/26/2023 14:30:00',
    'updated': '2024-05-14 06:50:55.117117'
},
{
    'applyNo': '2023011900003',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117119',
    'eventName': '有種一起來淨灘元宵活動',
    'id': 29,
    'location': '淡水貝殼海岸(羊稠子)，濱海路四段區間',
    'organizer': '力匯國際有種團隊',
    'participateNum': '15',
    'startTime': '02/05/2023 13:30:00',
    'updated': '2024-05-14 06:50:55.117123'
},
{
    'applyNo': '2023012400001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117134',
    'eventName': '2月5日(日)不廢青年_淺水灣~六塊厝淨灘',
    'id': 30,
    'location': '淺水灣，從沙湖路進去的沙崙湖海岸線',
    'organizer': '不廢青年',
    'participateNum': '50',
    'startTime': '02/05/2023 13:00:00',
    'updated': '2024-05-14 06:50:55.117136'
},
{
    'applyNo': '2023012600001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117136',
    'eventName': '【護眾生愛地球】公益淨灘',
    'id': 31,
    'location': '林口大坑站前海岸即「藍色公路海景咖啡館前海岸線」',
    'organizer': '淨心淨灘團',
    'participateNum': '20',
    'startTime': '02/11/2023 08:30:00',
    'updated': '2024-05-14 06:50:55.117137'
},
{
    'applyNo': '2023020300002',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117141',
    'eventName': '2023 RE-THINK x 菲力工業 新北八里淨灘',
    'id': 32,
    'location': '八里挖仔尾觀海長堤',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '250',
    'startTime': '02/11/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.117144'
},
{
    'applyNo': '2023020300003',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117148',
    'eventName': '2023 RE-THINK x 琺鈉生活 新北金山淨灘',
    'id': 33,
    'location': '新金山海水浴場',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '250',
    'startTime': '03/18/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.117157'
},
{
    'applyNo': '2023020300006',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117157',
    'eventName': '2023 RE-THINK x 菲力工業 新北八里淨灘',
    'id': 34,
    'location': '挖仔尾觀海長堤',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '250',
    'startTime': '03/11/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.117159'
},
{
    'applyNo': '2023020300011',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.117162',
    'eventName': '友善海洋 永續生活',
    'id': 35,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '200',
    'startTime': '03/25/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117166'
},
{
    'applyNo': '2023020300010',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.117169',
    'eventName': '友善海洋 永續生活',
    'id': 36,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '200',
    'startTime': '02/25/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117173'
},
{
    'applyNo': '2023020300009',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.117176',
    'eventName': '友善海洋 永續生活',
    'id': 37,
    'location': '苗栗縣後龍鎮南港漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '200',
    'startTime': '03/05/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.117180'
},
{
    'applyNo': '2023020300007',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.117183',
    'eventName': '2023年家庭環保日',
    'id': 38,
    'location': '清水區1段',
    'organizer': '張宛倩',
    'participateNum': '30',
    'startTime': '03/11/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117186'
},
{
    'applyNo': '2023020700001',
    'cityName': '屏東縣',
    'created': '2024-05-14 06:50:55.117190',
    'eventName': '海上與你，相約淨灘',
    'id': 39,
    'location': '屏東滿洲鄉漁村公園',
    'organizer': '烏町印製所',
    'participateNum': '6',
    'startTime': '02/28/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.117193'
},
{
    'applyNo': '2023020100001',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.117217',
    'eventName': '珍愛鑽石，守護沙灣',
    'id': 40,
    'location': '永安鑽石沙灣',
    'organizer': '雄讚海岸巡守志工隊',
    'participateNum': '20',
    'startTime': '02/19/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.117217'
},
{
    'applyNo': '2023021000008',
    'cityName': '花蓮縣',
    'created': '2024-05-14 06:50:55.117223',
    'eventName': '靈源淨灘公益活動',
    'id': 41,
    'location': '花蓮北濱公園',
    'organizer': '靈源社會服務團體',
    'participateNum': '100',
    'startTime': '03/04/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117226'
},
{
    'applyNo': '2023021400015',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117230',
    'eventName': '【護眾生愛地球】公益淨灘',
    'id': 42,
    'location': '林口大坑站前海岸即「藍色公路海景咖啡館前海岸線」',
    'organizer': '淨心淨灘團',
    'participateNum': '20',
    'startTime': '03/08/2023 08:30:00',
    'updated': '2024-05-14 06:50:55.117233'
},
{
    'applyNo': '2023021400008',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117237',
    'eventName': '2023愛的淨行式～「大手拉小手」 春季淨灘',
    'id': 43,
    'location': '中角灣國際衝浪基地',
    'organizer': '台北流行廣播電台',
    'participateNum': '200',
    'startTime': '03/12/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.117240'
},
{
    'applyNo': '2023021700005',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117244',
    'eventName': '海龜不哭X海樂森聯合淨灘',
    'id': 44,
    'location': '萬里海水浴場',
    'organizer': '海龜不哭',
    'participateNum': '100',
    'startTime': '03/25/2023 13:30:00',
    'updated': '2024-05-14 06:50:55.117254'
},
{
    'applyNo': '2023022000006',
    'cityName': '臺東縣',
    'created': '2024-05-14 06:50:55.117254',
    'eventName': '財團法人厚德福田社會福利慈善事業基金會 「淨海、敬海」春季淨灘活動',
    'id': 45,
    'location': '台東縣海濱公園段',
    'organizer': '財團法人厚德福田慈善事業基金會',
    'participateNum': '50',
    'startTime': '04/15/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.117254'
},
{
    'applyNo': '2023022000009',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117257',
    'eventName': '海洋需要你 齊心做公益',
    'id': 46,
    'location': '普羅旺斯景館餐廳',
    'organizer': '台灣房屋-家睦團隊',
    'participateNum': '100',
    'startTime': '03/11/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.117261'
},
{
    'applyNo': '2023022200001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117264',
    'eventName': '海龜不哭交友淨灘',
    'id': 47,
    'location': '野柳漁港旁的岩岸',
    'organizer': '海龜不哭',
    'participateNum': '70',
    'startTime': '03/26/2023 13:30:00',
    'updated': '2024-05-14 06:50:55.117274'
},
{
    'applyNo': '2023022200012',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117274',
    'eventName': '112年鴻元殿 家庭淨灘日',
    'id': 48,
    'location': '八里挖子尾海灘(觀海長堤左側海灘)',
    'organizer': '無極祖敕鴻元殿',
    'participateNum': '10',
    'startTime': '03/19/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117283'
},
{
    'applyNo': '2023022300009',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.117285',
    'eventName': '大家一起愛地球',
    'id': 49,
    'location': '高雄市旗津區旗津三路990號',
    'organizer': '萬有人力仲介有限公司',
    'participateNum': '25',
    'startTime': '03/31/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.117285'
},
{
    'applyNo': '2023020700005',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.117285',
    'eventName': '環保公益淨灘',
    'id': 50,
    'location': '蚵仔寮海灘',
    'organizer': '高雄市光明慈善文教協會',
    'participateNum': '40',
    'startTime': '03/11/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.117288'
},
{
    'applyNo': '2023021800002',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.117292',
    'eventName': '林園愛鄉淨灘活動',
    'id': 51,
    'location': '林園海洋濕地公園旁 林園段(二)',
    'organizer': '一卡通票證股份有限公司',
    'participateNum': '150',
    'startTime': '03/25/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.117295'
},
{
    'applyNo': '2023022000008',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.117305',
    'eventName': 'BSx赭石 淨灘趣',
    'id': 52,
    'location': '松柏漁港',
    'organizer': '蓉耀實業有限公司',
    'participateNum': '9',
    'startTime': '03/22/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.117305'
},
{
    'applyNo': '2023022700002',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117308',
    'eventName': '3月11日(六)不廢青年_淺水灣~六塊厝淨灘',
    'id': 53,
    'location': '淺水灣，從沙湖路進去的沙崙湖海岸線!',
    'organizer': '不廢青年',
    'participateNum': '50',
    'startTime': '03/11/2023 13:00:00',
    'updated': '2024-05-14 06:50:55.117312'
},
{
    'applyNo': '2023022800001',
    'cityName': '嘉義縣',
    'created': '2024-05-14 06:50:55.117315',
    'eventName': '淨灘龜心',
    'id': 54,
    'location': '好美里',
    'organizer': '三支小貓',
    'participateNum': '3',
    'startTime': '03/12/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.117318'
},
{
    'applyNo': '2023022700004',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117322',
    'eventName': '3月5日(日)不廢青年_淺水灣~六塊厝淨灘',
    'id': 55,
    'location': '淺水灣免費停車場到南海造船廠',
    'organizer': '不廢青年',
    'participateNum': '30',
    'startTime': '03/05/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.117325'
},
{
    'applyNo': '2023022700003',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117329',
    'eventName': '3月12日(日)不廢青年_淺水灣~六塊厝淨灘',
    'id': 56,
    'location': '淺水灣，從沙湖路進去的沙崙湖海岸線!',
    'organizer': '不廢青年',
    'participateNum': '50',
    'startTime': '03/12/2023 13:00:00',
    'updated': '2024-05-14 06:50:55.117332'
},
{
    'applyNo': '2023030200002',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.117335',
    'eventName': '蚵間海岸淨灘淨林一起來',
    'id': 57,
    'location': '桃園市新屋區蚵間海岸線',
    'organizer': '桃園市新屋區蚵間海岸巡護隊',
    'participateNum': '300',
    'startTime': '',
    'updated': '2024-05-14 06:50:55.117346'
},
{
    'applyNo': '2023011800008',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.117349',
    'eventName': '世界地球日-撿塑淨灘Follow me',
    'id': 58,
    'location': '基隆市大武崙沙灘(外木山)',
    'organizer': '浮米海洋戶外工作室',
    'participateNum': '35',
    'startTime': '04/22/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117349'
},
{
    'applyNo': '2023030500001',
    'cityName': '屏東縣',
    'created': '2024-05-14 06:50:55.117349',
    'eventName': '《海想見到你 See to sea 》屏東林邊崎峰月牙灣淨灘',
    'id': 59,
    'location': '屏東林邊崎峰月牙灣',
    'organizer': '國立屏東大學  偏鄉文化傳播-屏東東港南平社區團隊',
    'participateNum': '100',
    'startTime': '04/15/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.117353'
},
{
    'applyNo': '2023030600014',
    'cityName': '嘉義縣',
    'created': '2024-05-14 06:50:55.117356',
    'eventName': '2023年TOYOTA淨灘活動',
    'id': 60,
    'location': '好美里防風林 北處隄防入口處、海岸沙灘',
    'organizer': '南都汽車股份有限公司',
    'participateNum': '200',
    'startTime': '04/23/2023 07:00:00',
    'updated': '2024-05-14 06:50:55.117360'
},
{
    'applyNo': '2023030900001',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.117363',
    'eventName': '台南淨遊趣淨灘',
    'id': 61,
    'location': '國聖燈塔',
    'organizer': '台南淨遊趣',
    'participateNum': '80',
    'startTime': '03/11/2023 15:30:00',
    'updated': '2024-05-14 06:50:55.117366'
},
{
    'applyNo': '2023030600013',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.117377',
    'eventName': '2023年TOYOTA淨灘活動',
    'id': 62,
    'location': '觀夕平台週邊及沙灘',
    'organizer': '南都汽車股份有限公司',
    'participateNum': '800',
    'startTime': '04/23/2023 07:00:00',
    'updated': '2024-05-14 06:50:55.117377'
},
{
    'applyNo': '2023030500002',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117377',
    'eventName': '有種一起來淨灘',
    'id': 63,
    'location': '淡水沙崙海灘',
    'organizer': '力匯國際有種團隊',
    'participateNum': '12',
    'startTime': '03/19/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.117380'
},
{
    'applyNo': '2023030600016',
    'cityName': '雲林縣',
    'created': '2024-05-14 06:50:55.117392',
    'eventName': '2023年TOYOTA淨灘活動',
    'id': 64,
    'location': '雲林縣麥寮鄉雲1-4鄉道 海巡署 許厝寮安檢所前、週邊海灘',
    'organizer': '南都汽車股份有限公司',
    'participateNum': '100',
    'startTime': '04/23/2023 07:00:00',
    'updated': '2024-05-14 06:50:55.117392'
},
{
    'applyNo': '2023030600015',
    'cityName': '雲林縣',
    'created': '2024-05-14 06:50:55.117400',
    'eventName': '2023年TOYOTA淨灘活動',
    'id': 65,
    'location': '雲林縣麥寮鄉雲1-4鄉道 海巡署 許厝寮安檢所前、週邊海灘',
    'organizer': '南都汽車股份有限公司',
    'participateNum': '100',
    'startTime': '04/23/2023 07:00:00',
    'updated': '2024-05-14 06:50:55.117402'
},
{
    'applyNo': '2023031000001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117415',
    'eventName': '【淨灘淨心．麟山鼻】',
    'id': 66,
    'location': '石門區麟山鼻',
    'organizer': '中華佛教青年會',
    'participateNum': '60',
    'startTime': '04/08/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.117419'
},
{
    'applyNo': '2023031300010',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.117422',
    'eventName': '2023 RE-THINK x 國聚建設 台中西勢海堤淨灘',
    'id': 67,
    'location': '西勢海堤',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '350',
    'startTime': '04/15/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.117426'
},
{
    'applyNo': '2023031200001',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.117429',
    'eventName': '喜悅淨灘',
    'id': 68,
    'location': '基隆外木山龍蝦麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '20',
    'startTime': '04/01/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.117432'
},
{
    'applyNo': '2023031300003',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.117436',
    'eventName': '渣打銀行R5淨攤志工日',
    'id': 69,
    'location': '漁光島',
    'organizer': '渣打銀行',
    'participateNum': '30',
    'startTime': '05/01/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117439'
},
{
    'applyNo': '2023031100001',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.117443',
    'eventName': '聯手淨攤、愛上安聯；元培明新、愛上聯新',
    'id': 70,
    'location': '永安漁港南岸第三段',
    'organizer': '安聯人壽保險股份有限公司-聯新通訊處',
    'participateNum': '40',
    'startTime': '04/23/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117446'
},
{
    'applyNo': '2023031200002',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.117449',
    'eventName': '旅行淨灘',
    'id': 71,
    'location': '基隆外木山龍蝦麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '30',
    'startTime': '04/15/2023 14:30:00',
    'updated': '2024-05-14 06:50:55.117453'
},
{
    'applyNo': '2023031300005',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.117456',
    'eventName': '第十四屆聯新國際家庭健康促進日 「親子攜手聯合淨灘」',
    'id': 72,
    'location': '桃園市永安漁港南岸第3段',
    'organizer': '聯新國際醫院教學處',
    'participateNum': '200',
    'startTime': '06/11/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.117460'
},
{
    'applyNo': '2023031200003',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.117463',
    'eventName': '一起淨灘',
    'id': 73,
    'location': '基隆外木山龍蝦麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '30',
    'startTime': '04/22/2023 14:30:00',
    'updated': '2024-05-14 06:50:55.117467'
},
{
    'applyNo': '2023030900008',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.117470',
    'eventName': '2023海客任務:淨力而為',
    'id': 74,
    'location': '石滬故事館周圍灘岸',
    'organizer': '桃園市新屋區愛鄉協會',
    'participateNum': '500',
    'startTime': '04/22/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.117473'
},
{
    'applyNo': '2023031400013',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.117477',
    'eventName': '頭城淨灘闖關',
    'id': 75,
    'location': '開蘭路298號1樓',
    'organizer': '浪慢工作室',
    'participateNum': '20',
    'startTime': '03/26/2023 13:00:00',
    'updated': '2024-05-14 06:50:55.117480'
},
{
    'applyNo': '2023031500011',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.117483',
    'eventName': '點亮彰化點亮海洋',
    'id': 76,
    'location': '線西番雅溝',
    'organizer': '彰化市民生國小',
    'participateNum': '100',
    'startTime': '04/09/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.117487'
},
{
    'applyNo': '2023031300009',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117491',
    'eventName': '2023 RE-THINK x 思博特 新北林口淨灘',
    'id': 77,
    'location': '林口中福守望哨',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '350',
    'startTime': '04/08/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.117494'
},
{
    'applyNo': '2023032000009',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.117498',
    'eventName': '友善海洋 永續生活',
    'id': 78,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '200',
    'startTime': '04/16/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117501'
},
{
    'applyNo': '2023031700015',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117507',
    'eventName': '新鈺生技企業淨灘活動-中角灣',
    'id': 79,
    'location': '金山區中角灣',
    'organizer': '新鈺生技股份有限公司',
    'participateNum': '20',
    'startTime': '04/14/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.117511'
},
{
    'applyNo': '2023032000021',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117514',
    'eventName': '【護眾生愛地球】公益淨灘',
    'id': 80,
    'location': '林口大坑站前海岸即「藍色公路海景咖啡館前海岸線」',
    'organizer': '淨心淨灘團',
    'participateNum': '20',
    'startTime': '04/19/2023 08:30:00',
    'updated': '2024-05-14 06:50:55.117517'
},
{
    'applyNo': '2023031300019',
    'cityName': '新竹市',
    'created': '2024-05-14 06:50:55.117521',
    'eventName': '愛上海洋淨灘救援',
    'id': 81,
    'location': '活動地點:魚鱗天梯',
    'organizer': '亞洲科莫丹股份有限公司',
    'participateNum': '40',
    'startTime': '07/02/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.117524'
},
{
    'applyNo': '2023032100013',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.117527',
    'eventName': '皇家環保淨灘日',
    'id': 82,
    'location': '伸港鄉蚵寮海岸',
    'organizer': '彰化皇家扶輪社',
    'participateNum': '15',
    'startTime': '04/30/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.117531'
},
{
    'applyNo': '2023032100006',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.117534',
    'eventName': '2023用愛環抱海洋 企業淨灘GO',
    'id': 83,
    'location': '高雄林園海洋濕地公園前沙灘（高雄市林園區半廓路）',
    'organizer': '財團法人福智文教基金會',
    'participateNum': '700',
    'startTime': '04/22/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.117538'
},
{
    'applyNo': '2023032100010',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.117541',
    'eventName': '淨灘',
    'id': 84,
    'location': '通霄火力發電廠',
    'organizer': '嘉洛展有限公司',
    'participateNum': '6',
    'startTime': '03/29/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.117544'
},
{
    'applyNo': '2023032400001',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.117548',
    'eventName': '第16場公開行動',
    'id': 85,
    'location': '蘇澳澳仔角',
    'organizer': '海邊的接力賽',
    'participateNum': '10',
    'startTime': '03/28/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117551'
},
{
    'applyNo': '2023032300009',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.117555',
    'eventName': '4/5清明節 大園沙崙淨灘！',
    'id': 86,
    'location': '大園沙崙海灘',
    'organizer': '海湧工作室有限公司',
    'participateNum': '100',
    'startTime': '04/05/2023 14:30:00',
    'updated': '2024-05-14 06:50:55.117558'
},
{
    'applyNo': '2023032400005',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.117561',
    'eventName': '環保公益淨灘',
    'id': 87,
    'location': '蚵仔寮海灘',
    'organizer': '高雄市光明慈善文教協會',
    'participateNum': '40',
    'startTime': '04/02/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.117565'
},
{
    'applyNo': '2023032500003',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.117568',
    'eventName': '環保公益淨灘',
    'id': 88,
    'location': '蚵仔寮海灘',
    'organizer': '高雄市光明慈善文教協會',
    'participateNum': '30',
    'startTime': '06/10/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.117572'
},
{
    'applyNo': '2023032500002',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.117575',
    'eventName': '環保公益淨灘',
    'id': 89,
    'location': '蚵仔寮海灘',
    'organizer': '高雄市光明慈善文教協會',
    'participateNum': '30',
    'startTime': '05/06/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.117578'
},
{
    'applyNo': '2023032700012',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.117582',
    'eventName': '瀚你一起來淨灘',
    'id': 90,
    'location': '白沙屯漁港',
    'organizer': '台中安聯人壽（瀚鼎通訊處',
    'participateNum': '80',
    'startTime': '04/29/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117588'
},
{
    'applyNo': '2023032800008',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117591',
    'eventName': '國際海洋清潔日淨海淨灘活動',
    'id': 91,
    'location': '龍洞灣',
    'organizer': '藍色海洋星球',
    'participateNum': '30',
    'startTime': '06/03/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.117595'
},
{
    'applyNo': '2023032800007',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.117600',
    'eventName': '海上與你，相約淨灘',
    'id': 92,
    'location': '台中大安區龜殼里',
    'organizer': '烏町印製所',
    'participateNum': '6',
    'startTime': '04/04/2023 15:30:00',
    'updated': '2024-05-14 06:50:55.117604'
},
{
    'applyNo': '2023032900006',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.117607',
    'eventName': '我們的布尿布日記淨灘活動',
    'id': 93,
    'location': '安平橋頭海灘公園',
    'organizer': '我們的布尿布日記（台南地區）',
    'participateNum': '30',
    'startTime': '05/20/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117611'
},
{
    'applyNo': '2023033100004',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.117614',
    'eventName': '淨灘',
    'id': 94,
    'location': '橋頭海灘公園',
    'organizer': '台南淨遊趣',
    'participateNum': '50',
    'startTime': '04/16/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117618'
},
{
    'applyNo': '2023040600006',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.117621',
    'eventName': '一切淨好',
    'id': 95,
    'location': '觀音濱海休憩區（原觀音海水浴場）',
    'organizer': '心成教育',
    'participateNum': '50',
    'startTime': '05/06/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117624'
},
{
    'applyNo': '2023040300003',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117628',
    'eventName': '板橋高中22屆生研社淨灘活動',
    'id': 96,
    'location': '萬里螃蟹公園',
    'organizer': '板橋高中生研社',
    'participateNum': '9',
    'startTime': '04/16/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.117631'
},
{
    'applyNo': '2023040100002',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.117635',
    'eventName': '海灘清道夫',
    'id': 97,
    'location': 'Google地圖搜尋觀海景台',
    'organizer': '社團法人臺中市擲筊文化傳承協會',
    'participateNum': '20',
    'startTime': '05/21/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117638'
},
{
    'applyNo': '2023040700007',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.117641',
    'eventName': '淨灘愛地球',
    'id': 98,
    'location': '永安漁港',
    'organizer': '凱基證劵',
    'participateNum': '21',
    'startTime': '04/29/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.117645'
},
{
    'applyNo': '2023033100001',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.117648',
    'eventName': '蚵間海岸淨灘淨林一起來',
    'id': 99,
    'location': '桃園市新屋區蚵間海岸林',
    'organizer': '桃園市新屋區蚵間海岸巡護隊',
    'participateNum': '100',
    'startTime': '04/15/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117652'
},
{
    'applyNo': '2023040600025',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.117655',
    'eventName': '4/29 Remove 旗津淨灘活動',
    'id': 100,
    'location': '旗津',
    'organizer': '個人-黃立嘉(Remove淨灘)',
    'participateNum': '20',
    'startTime': '04/29/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117658'
},
{
    'applyNo': '2022080300004',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117662',
    'eventName': '婚禮人淨灘 ',
    'id': 101,
    'location': '紅海灘 ',
    'organizer': '中華婚禮文化發展協會 ',
    'participateNum': '50',
    'startTime': '08/22/2022 16:00:00',
    'updated': '2024-05-14 06:50:55.117665'
},
{
    'applyNo': '2023040600028',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.117668',
    'eventName': '正能量手護海洋',
    'id': 102,
    'location': '龍蝦麻糬對面海灘',
    'organizer': '財團法人釋迦牟尼佛救世基金會(基隆禪宗印心會館)',
    'participateNum': '100',
    'startTime': '06/11/2023 07:00:00',
    'updated': '2024-05-14 06:50:55.117672'
},
{
    'applyNo': '2023040800001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117675',
    'eventName': '海龜不哭X淨灘交友',
    'id': 103,
    'location': '野柳岩岸',
    'organizer': '海龜不哭淨灘活99',
    'participateNum': '100',
    'startTime': '04/30/2023 13:30:00',
    'updated': '2024-05-14 06:50:55.117678'
},
{
    'applyNo': '2023041000008',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117682',
    'eventName': '桃園機場昇恆昌淨灘活動',
    'id': 104,
    'location': '林口嘉寶里福德宮前海灘',
    'organizer': '昇恆昌股份有限公司',
    'participateNum': '50',
    'startTime': '05/06/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.117685'
},
{
    'applyNo': '2022090100016',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.117691',
    'eventName': '2022 KIRIN 獵奇海廢大搜查 淨灘活動',
    'id': 105,
    'location': '桃園後厝港',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '250',
    'startTime': '11/05/2022 15:30:00',
    'updated': '2024-05-14 06:50:55.117695'
},
{
    'applyNo': '2023041000009',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.117698',
    'eventName': '台灣美光記憶體股份有限公司 (DEG部門)',
    'id': 106,
    'location': '大安濱海樂園',
    'organizer': '台灣美光記憶體股份有限公司',
    'participateNum': '100',
    'startTime': '04/20/2023 13:00:00',
    'updated': '2024-05-14 06:50:55.117702'
},
{
    'applyNo': '2023031600004',
    'cityName': '新竹市',
    'created': '2024-05-14 06:50:55.117705',
    'eventName': '2023 世界地球日 — 淨灘兌換永續海鮮活動',
    'id': 107,
    'location': '魚鱗天梯周圍海灘 (新竹市北區新港路旁)',
    'organizer': '財團法人臺灣海洋保育與漁業永續基金會',
    'participateNum': '250',
    'startTime': '04/22/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.117708'
},
{
    'applyNo': '2023041100001',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.117712',
    'eventName': '愛護海洋靠你我淨灘活動',
    'id': 108,
    'location': '彰化縣伸港鄉曾家村海岸線',
    'organizer': '溪湖國中',
    'participateNum': '120',
    'startTime': '05/25/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117715'
},
{
    'applyNo': '2023040600031',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117719',
    'eventName': '義起淨心淨力，手護海洋由我做起',
    'id': 109,
    'location': '淡水洲子灣海岸',
    'organizer': '個人',
    'participateNum': '250',
    'startTime': '',
    'updated': '2024-05-14 06:50:55.117722'
},
{
    'applyNo': '2023041000018',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.117726',
    'eventName': '宏泰人壽淨灘海廢撿起來',
    'id': 110,
    'location': '頭城竹安出海口南側',
    'organizer': '海邊的接力賽',
    'participateNum': '100',
    'startTime': '04/22/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117729'
},
{
    'applyNo': '2023041200005',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117732',
    'eventName': '海龜不哭X麗嬰房淨灘',
    'id': 111,
    'location': '萬里海水浴場',
    'organizer': '海龜不哭',
    'participateNum': '600',
    'startTime': '05/28/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.117736'
},
{
    'applyNo': '2023041000019',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.117739',
    'eventName': '耕牛小學堂聯名公益行動',
    'id': 112,
    'location': '大福景觀台',
    'organizer': '海邊的接力賽',
    'participateNum': '50',
    'startTime': '04/22/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.117742'
},
{
    'applyNo': '2022102000007',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.117746',
    'eventName': '海龜不哭淨灘活99',
    'id': 113,
    'location': '觀音海水浴場',
    'organizer': '海龜不哭淨灘活99',
    'participateNum': '50',
    'startTime': '11/05/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.117749'
},
{
    'applyNo': '2023041300012',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.117753',
    'eventName': '2023 春遊台南-淨灘趣',
    'id': 114,
    'location': '漁光島',
    'organizer': '台中科技大學 賢青社',
    'participateNum': '20',
    'startTime': '04/30/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117756'
},
{
    'applyNo': '2023041400008',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.117759',
    'eventName': '臺灣通用磨坊淨灘',
    'id': 115,
    'location': '基隆外木山龍蝦麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '25',
    'startTime': '04/23/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117765'
},
{
    'applyNo': '2023041400013',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.117769',
    'eventName': '富盈睿智台中淨灘活動',
    'id': 116,
    'location': '台中市清水區環港北路海角明珠（高美風車大到底）',
    'organizer': '富盈睿智保險經紀人股份有限公司',
    'participateNum': '30',
    'startTime': '05/24/2023 08:30:00',
    'updated': '2024-05-14 06:50:55.117772'
},
{
    'applyNo': '2022092900014',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.117776',
    'eventName': '2022淨灘減塑愛地球',
    'id': 117,
    'location': '麗水漁港河堤',
    'organizer': '臺中市百合國際傑人會',
    'participateNum': '10',
    'startTime': '10/15/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.117779'
},
{
    'applyNo': '2023041400001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117785',
    'eventName': '大家來海邊撿垃圾',
    'id': 118,
    'location': '林口嘉寶海灘',
    'organizer': '陳品謙',
    'participateNum': '20',
    'startTime': '05/13/2023 16:00:00',
    'updated': '2024-05-14 06:50:55.117788'
},
{
    'applyNo': '2023041800002',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.117792',
    'eventName': '台中市足球俱樂部TCFC淨灘日',
    'id': 119,
    'location': '台中市清水區清水區1段',
    'organizer': '台中市足球俱樂部TCFC',
    'participateNum': '20',
    'startTime': '05/27/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.117795'
},
{
    'applyNo': '2022100200006',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.117799',
    'eventName': '11月27日_不廢青年_ 桃園竹圍~後厝淨灘',
    'id': 120,
    'location': '桃園竹圍~後厝淨灘',
    'organizer': '不廢青年',
    'participateNum': '200',
    'startTime': '11/27/2022 13:00:00',
    'updated': '2024-05-14 06:50:55.117802'
},
{
    'applyNo': '2022102600014',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.117808',
    'eventName': '淨灘活動',
    'id': 121,
    'location': '基隆',
    'organizer': '凱基證券',
    'participateNum': '6',
    'startTime': '11/06/2022 08:00:00',
    'updated': '2024-05-14 06:50:55.117811'
},
{
    'applyNo': '2022071000001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117814',
    'eventName': 'BingX淨灘活動',
    'id': 122,
    'location': '林口南灣頭海岸',
    'organizer': '壹時代科技有限公司',
    'participateNum': '40',
    'startTime': '07/24/2022 14:00:00',
    'updated': '2024-05-14 06:50:55.117818'
},
{
    'applyNo': '2022070800003',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.117821',
    'eventName': '「雄」愛海洋一起「讚」出來愛護它',
    'id': 123,
    'location': '梓官蚵仔寮沙灘',
    'organizer': '雄讚海岸巡守志工隊',
    'participateNum': '40',
    'startTime': '07/24/2022 08:00:00',
    'updated': '2024-05-14 06:50:55.117825'
},
{
    'applyNo': '2022092000003',
    'cityName': '臺東縣',
    'created': '2024-05-14 06:50:55.117828',
    'eventName': '大學淨灘團',
    'id': 124,
    'location': '台東市海濱公園',
    'organizer': '私人',
    'participateNum': '10',
    'startTime': '11/19/2022 15:00:00',
    'updated': '2024-05-14 06:50:55.117831'
},
{
    'applyNo': '2022070700005',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.117835',
    'eventName': '夏令營環境保護淨灘體驗',
    'id': 125,
    'location': '黃金海岸',
    'organizer': '悅讀文理補習班',
    'participateNum': '30',
    'startTime': '07/12/2022 09:35:00',
    'updated': '2024-05-14 06:50:55.117838'
},
{
    'applyNo': '2022070700006',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117842',
    'eventName': '2022 荒野 愛海無懼 淨灘活動',
    'id': 126,
    'location': '十八王公橋底下',
    'organizer': '荒野保護協會',
    'participateNum': '300',
    'startTime': '09/17/2022 08:00:00',
    'updated': '2024-05-14 06:50:55.117845'
},
{
    'applyNo': '2022072100005',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.117848',
    'eventName': '腦性麻痺海洋教育活動',
    'id': 127,
    'location': '旗津貝殼館沙灘',
    'organizer': '台灣海洋環境教育推廣協會',
    'participateNum': '70',
    'startTime': '08/25/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.117852'
},
{
    'applyNo': '2022063000001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117860',
    'eventName': '淨灘活動',
    'id': 128,
    'location': '林口頂寮沙灘',
    'organizer': '卡樂教室',
    'participateNum': '10',
    'startTime': '07/13/2022 10:00:00',
    'updated': '2024-05-14 06:50:55.117864'
},
{
    'applyNo': '2022063000002',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117868',
    'eventName': '救愛淨灘',
    'id': 129,
    'location': '淡水沙崙海灘',
    'organizer': '財團法人基督教救世軍內湖隊',
    'participateNum': '20',
    'startTime': '07/14/2022 14:00:00',
    'updated': '2024-05-14 06:50:55.117872'
},
{
    'applyNo': '2022070100002',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.117875',
    'eventName': '淨灘活動',
    'id': 130,
    'location': '烏石港',
    'organizer': '錠嵂保險經紀人公司北六營業處',
    'participateNum': '40',
    'startTime': '07/08/2022 11:30:00',
    'updated': '2024-05-14 06:50:55.117879'
},
{
    'applyNo': '2022070500004',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.117886',
    'eventName': '攜手護海洋',
    'id': 131,
    'location': '肉粽角',
    'organizer': '彰化市民生國小',
    'participateNum': '50',
    'startTime': '07/19/2022 08:00:00',
    'updated': '2024-05-14 06:50:55.117890'
},
{
    'applyNo': '2022070500007',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.117894',
    'eventName': '瑞哥搞事很哇賽',
    'id': 132,
    'location': '高雄林園濕地公園',
    'organizer': '夢飛翔娛樂',
    'participateNum': '50',
    'startTime': '07/23/2022 14:00:00',
    'updated': '2024-05-14 06:50:55.117897'
},
{
    'applyNo': '2022070600002',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.117900',
    'eventName': '太平洋房屋全台千人牽手護家園-淨灘減塑',
    'id': 133,
    'location': '桃園市觀音區小飯壢溪至觀音溪沿岸',
    'organizer': '太平洋房屋桃竹苗區經委會',
    'participateNum': '200',
    'startTime': '08/17/2022 09:30:00',
    'updated': '2024-05-14 06:50:55.117904'
},
{
    'applyNo': '2022070700007',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.117907',
    'eventName': '二鹿文化體驗暨淨攤活動',
    'id': 134,
    'location': '肉粽角沙灘',
    'organizer': '明道大學數位設計學系、數位遊戲暨APP開發研究學習社、校安暨環安中心',
    'participateNum': '30',
    'startTime': '07/10/2022 15:00:00',
    'updated': '2024-05-14 06:50:55.117911'
},
{
    'applyNo': '2022070900001',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.117914',
    'eventName': '學習歷程奴隸',
    'id': 135,
    'location': '八斗子平浪橋海岸',
    'organizer': '基隆市二信中學學生',
    'participateNum': '6',
    'startTime': '07/16/2022 14:00:00',
    'updated': '2024-05-14 06:50:55.117917'
},
{
    'applyNo': '2022071000002',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.117921',
    'eventName': '第七場公開行動',
    'id': 136,
    'location': '頭城大溪，蕃薯溪出海口',
    'organizer': '海邊的接力賽',
    'participateNum': '10',
    'startTime': '07/26/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.117924'
},
{
    'applyNo': '2022071100001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117928',
    'eventName': '舉手之勞做淨灘',
    'id': 137,
    'location': '沙崙沙灘',
    'organizer': '凱基證券物管部',
    'participateNum': '45',
    'startTime': '07/31/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.117931'
},
{
    'applyNo': '2022071100003',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.117934',
    'eventName': '愛地球',
    'id': 138,
    'location': '海提沙洲',
    'organizer': '美尼亞國際有限公司',
    'participateNum': '100',
    'startTime': '08/27/2022 06:00:00',
    'updated': '2024-05-14 06:50:55.117938'
},
{
    'applyNo': '2022071100007',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.117941',
    'eventName': '淨灘',
    'id': 139,
    'location': '旗津貝殼館',
    'organizer': '日月光半導體製造股份有限公司',
    'participateNum': '100',
    'startTime': '07/23/2022 08:30:00',
    'updated': '2024-05-14 06:50:55.117944'
},
{
    'applyNo': '2022071700001',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.117948',
    'eventName': '7/24（日）淨灘瑜伽公益活動',
    'id': 140,
    'location': '龍鳳漁港',
    'organizer': '馨 yoga life',
    'participateNum': '50',
    'startTime': '07/24/2022 16:30:00',
    'updated': '2024-05-14 06:50:55.117954'
},
{
    'applyNo': '2022071900006',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.117957',
    'eventName': '仁愛海洋',
    'id': 141,
    'location': '大甲區西勢海堤沙灘',
    'organizer': '社團法人台中市仁愛獅子會',
    'participateNum': '300',
    'startTime': '09/18/2022 08:30:00',
    'updated': '2024-05-14 06:50:55.117961'
},
{
    'applyNo': '2022072100003',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.117964',
    'eventName': '腦性麻痺海洋教育活動',
    'id': 142,
    'location': '蘇澳鎮無尾港沙灘',
    'organizer': '台灣海洋環境教育推廣協會',
    'participateNum': '130',
    'startTime': '08/17/2022 10:00:00',
    'updated': '2024-05-14 06:50:55.117967'
},
{
    'applyNo': '2022072100006',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.117971',
    'eventName': '腦性麻痺海洋教育活動',
    'id': 143,
    'location': '金山青年活動中心沙灘',
    'organizer': '台灣海洋環境教育推廣協會',
    'participateNum': '70',
    'startTime': '09/04/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.117974'
},
{
    'applyNo': '2022072700002',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.117980',
    'eventName': '0807大園後厝港 淨灘活動',
    'id': 144,
    'location': '大園後厝港 25°06\'23.9"N 121°12\'34.8"E',
    'organizer': '淨灘台灣淨灘顧地球Taiwan',
    'participateNum': '20',
    'startTime': '08/07/2022 07:30:00',
    'updated': '2024-05-14 06:50:55.118001'
},
{
    'applyNo': '2022072500003',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118011',
    'eventName': '【護眾生愛地球】公益淨灘',
    'id': 145,
    'location': '林口大坑站前海岸即「藍色公路海景咖啡館前海岸線」',
    'organizer': '淨心淨灘團',
    'participateNum': '30',
    'startTime': '08/13/2022 08:00:00',
    'updated': '2024-05-14 06:50:55.118011'
},
{
    'applyNo': '2022072500005',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.118013',
    'eventName': '環保公益淨灘',
    'id': 146,
    'location': '蚵仔寮海灘',
    'organizer': '高雄市光明慈善文教協會',
    'participateNum': '40',
    'startTime': '08/07/2022 08:00:00',
    'updated': '2024-05-14 06:50:55.118016'
},
{
    'applyNo': '2022072600002',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.118027',
    'eventName': '111年度減塑淨灘17GO',
    'id': 147,
    'location': '長青之森出海口沙灘',
    'organizer': '裕鼎股份有限公司',
    'participateNum': '200',
    'startTime': '08/27/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.118030'
},
{
    'applyNo': '2022072700001',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118035',
    'eventName': '0806大園後厝港 淨灘活動',
    'id': 148,
    'location': '大園後厝港 25°06\'23.9"N 121°12\'34.8"E',
    'organizer': '淨灘台灣淨灘顧地球Taiwan',
    'participateNum': '20',
    'startTime': '08/06/2022 07:30:00',
    'updated': '2024-05-14 06:50:55.118035'
},
{
    'applyNo': '2023051900002',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118035',
    'eventName': '112年5月淨灘活動',
    'id': 149,
    'location': '竹圍漁港遊憩沙灘',
    'organizer': '中華民國社團法人英才環境保護暨發展協會',
    'participateNum': '20',
    'startTime': '05/28/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.118037'
},
{
    'applyNo': '2022072700003',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118040',
    'eventName': '0813大園後厝港 淨灘活動',
    'id': 150,
    'location': '大園後厝港 25°06\'23.9"N 121°12\'34.8"E',
    'organizer': '淨灘台灣淨灘顧地球Taiwan',
    'participateNum': '20',
    'startTime': '08/13/2022 07:30:00',
    'updated': '2024-05-14 06:50:55.118044'
},
{
    'applyNo': '2022081100003',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118047',
    'eventName': '2022 KIRIN 獵奇海廢大搜查 淨灘活動',
    'id': 151,
    'location': '新北貢寮和美',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '200',
    'startTime': '09/24/2022 15:30:00',
    'updated': '2024-05-14 06:50:55.118050'
},
{
    'applyNo': '2022072700005',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.118054',
    'eventName': '淨灘活動',
    'id': 152,
    'location': '五結鄉利澤段埤仔尾海灘及進出道路',
    'organizer': '石牌信友堂',
    'participateNum': '40',
    'startTime': '10/01/2022 15:00:00',
    'updated': '2024-05-14 06:50:55.118057'
},
{
    'applyNo': '2022080100003',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.118061',
    'eventName': '愛在蚵仔寮，淨灘愛地球',
    'id': 153,
    'location': '梓官竹筏港公園',
    'organizer': '雄讚海岸巡守志工隊',
    'participateNum': '40',
    'startTime': '08/14/2022 15:00:00',
    'updated': '2024-05-14 06:50:55.118064'
},
{
    'applyNo': '2022080200003',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.118068',
    'eventName': '環保救地球',
    'id': 154,
    'location': '龍鳳漁港',
    'organizer': '社團法人苗栗縣身心障礙福利協進會',
    'participateNum': '30',
    'startTime': '09/28/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.118071'
},
{
    'applyNo': '2022080200007',
    'cityName': '臺東縣',
    'created': '2024-05-14 06:50:55.118074',
    'eventName': '111年度綠島鄉淨灘活動',
    'id': 155,
    'location': '綠島鄉紫坪',
    'organizer': '臺東縣環境保護局',
    'participateNum': '30',
    'startTime': '08/12/2022 08:00:00',
    'updated': '2024-05-14 06:50:55.118078'
},
{
    'applyNo': '2022080400005',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118081',
    'eventName': '就要一起 Let’s do it  夏日淨灘活動',
    'id': 156,
    'location': '八里區挖子尾海灘',
    'organizer': 'CGM基督教福音宣教會主勝利分會',
    'participateNum': '200',
    'startTime': '09/17/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.118084'
},
{
    'applyNo': '2022080400011',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.118091',
    'eventName': '第八場公開行動',
    'id': 157,
    'location': '蘇澳大坑罟',
    'organizer': '海邊的接力賽',
    'participateNum': '20',
    'startTime': '08/20/2022 16:30:00',
    'updated': '2024-05-14 06:50:55.118094'
},
{
    'applyNo': '2022080700002',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.118098',
    'eventName': '友善海洋 永續生活',
    'id': 158,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '150',
    'startTime': '08/21/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.118101'
},
{
    'applyNo': '2022081000006',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.118104',
    'eventName': '環保公益淨灘',
    'id': 159,
    'location': '蚵仔寮海灘',
    'organizer': '高雄市光明慈善文教協會',
    'participateNum': '40',
    'startTime': '09/04/2022 08:00:00',
    'updated': '2024-05-14 06:50:55.118108'
},
{
    'applyNo': '2022081100002',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118111',
    'eventName': '2022 清潔日淨灘行動',
    'id': 160,
    'location': '新北林口頂寮沙灘',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '200',
    'startTime': '09/17/2022 15:30:00',
    'updated': '2024-05-14 06:50:55.118114'
},
{
    'applyNo': '2022081500005',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118118',
    'eventName': '護眾生愛地球-公益淨灘',
    'id': 161,
    'location': '林口大坑站前海岸即「藍色公路海景咖啡館前海岸線」',
    'organizer': '淨心淨灘團',
    'participateNum': '30',
    'startTime': '09/07/2022 08:00:00',
    'updated': '2024-05-14 06:50:55.118121'
},
{
    'applyNo': '2022081700004',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118125',
    'eventName': '海岸淨灘暨海洋保育',
    'id': 162,
    'location': '竹圍海水浴場',
    'organizer': '台北市南海扶輪青年服務社',
    'participateNum': '20',
    'startTime': '08/27/2022 10:00:00',
    'updated': '2024-05-14 06:50:55.118128'
},
{
    'applyNo': '2022081700015',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.118132',
    'eventName': '8/21台中大安海水浴場淨灘',
    'id': 163,
    'location': '台中大安海水浴場',
    'organizer': '陳翺（個人）',
    'participateNum': '100',
    'startTime': '08/21/2022 15:00:00',
    'updated': '2024-05-14 06:50:55.118135'
},
{
    'applyNo': '2022081800006',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.118138',
    'eventName': 'Double Green Day in Tainan',
    'id': 164,
    'location': '安平觀夕平台',
    'organizer': '普世博愛運動',
    'participateNum': '15',
    'startTime': '09/17/2022 15:00:00',
    'updated': '2024-05-14 06:50:55.118142'
},
{
    'applyNo': '2022082200001',
    'cityName': '嘉義縣',
    'created': '2024-05-14 06:50:55.118145',
    'eventName': 'NextGen Beach Cleanup',
    'id': 165,
    'location': '布袋漁港',
    'organizer': '財團法人台灣世代教育基金會',
    'participateNum': '15',
    'startTime': '08/28/2022 15:00:00',
    'updated': '2024-05-14 06:50:55.118151'
},
{
    'applyNo': '2022082300006',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.118155',
    'eventName': '2022 0827 台南淨遊趣淨灘',
    'id': 166,
    'location': '漁光島北邊，秋茂園鐘樓集合',
    'organizer': '台南淨灘趣',
    'participateNum': '50',
    'startTime': '08/27/2022 17:00:00',
    'updated': '2024-05-14 06:50:55.118158'
},
{
    'applyNo': '2022082400007',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118161',
    'eventName': '新鈺生技企業淨灘活動-中角灣',
    'id': 167,
    'location': '金山區中角灣',
    'organizer': '新鈺生技股份有限公司',
    'participateNum': '15',
    'startTime': '09/16/2022 14:00:00',
    'updated': '2024-05-14 06:50:55.118165'
},
{
    'applyNo': '2022081600002',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118168',
    'eventName': '永續 淨。行。識',
    'id': 168,
    'location': '桃園觀音段草漯沙丘觀音展示館',
    'organizer': '社團法人桃園市萱藝新知關懷協會',
    'participateNum': '70',
    'startTime': '09/17/2022 08:00:00',
    'updated': '2024-05-14 06:50:55.118171'
},
{
    'applyNo': '2022082900004',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.118175',
    'eventName': '林園海洋濕地公園海岸巡檢及淨攤',
    'id': 169,
    'location': '林園海洋濕地公園',
    'organizer': '林園愛鄉協會海岸巡守隊',
    'participateNum': '50',
    'startTime': '09/17/2022 14:00:00',
    'updated': '2024-05-14 06:50:55.118178'
},
{
    'applyNo': '2022083100001',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118184',
    'eventName': '永續環境，行動愛台',
    'id': 170,
    'location': '老街溪河口右岸約500公尺範圍',
    'organizer': '台灣基督長老教會大園教會',
    'participateNum': '150',
    'startTime': '09/24/2022 14:00:00',
    'updated': '2024-05-14 06:50:55.118188'
},
{
    'applyNo': '2022083100003',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.118191',
    'eventName': '龍舟隊淨灘',
    'id': 171,
    'location': '大武崙沙灘',
    'organizer': '遊戲橘子',
    'participateNum': '15',
    'startTime': '09/17/2022 08:00:00',
    'updated': '2024-05-14 06:50:55.118194'
},
{
    'applyNo': '2022090100015',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.118198',
    'eventName': '2022 KIRIN 獵奇海廢大搜查 淨灘活動',
    'id': 172,
    'location': '阿公店溪出海口南岸',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '200',
    'startTime': '10/08/2022 15:30:00',
    'updated': '2024-05-14 06:50:55.118201'
},
{
    'applyNo': '2022090200001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118205',
    'eventName': '凱基證券揪團來淨灘志工活動(人資)',
    'id': 173,
    'location': '淡水沙崙海灘',
    'organizer': '凱基證券人力資源部',
    'participateNum': '15',
    'startTime': '09/24/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.118209'
},
{
    'applyNo': '2022090200007',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.118212',
    'eventName': '友善海洋 永續生活',
    'id': 174,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '150',
    'startTime': '09/18/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.118215'
},
{
    'applyNo': '2022090500009',
    'cityName': '新竹市',
    'created': '2024-05-14 06:50:55.118219',
    'eventName': '威力淨灘趣 ',
    'id': 175,
    'location': '新竹看海公園',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '200',
    'startTime': '10/16/2022 10:00:00',
    'updated': '2024-05-14 06:50:55.118222'
},
{
    'applyNo': '2022090700010',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118225',
    'eventName': '中角灣淨灘',
    'id': 176,
    'location': '中角灣',
    'organizer': '台北市北區榮美教會',
    'participateNum': '15',
    'startTime': '09/17/2022 14:00:00',
    'updated': '2024-05-14 06:50:55.118229'
},
{
    'applyNo': '2022091900005',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.118232',
    'eventName': '淨灘活動',
    'id': 177,
    'location': '大甲區堤防路386號旁',
    'organizer': '台中東南扶青社',
    'participateNum': '30',
    'startTime': '10/15/2022 08:30:00',
    'updated': '2024-05-14 06:50:55.118236'
},
{
    'applyNo': '2022090800013',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.118239',
    'eventName': '2022國際淨灘行動-台中0918-愛海無ㄐㄩˋ海裡沒有我的塑',
    'id': 178,
    'location': '台中市大甲區松柏與港北邊船頭埔海堤與南邊西勢海堤',
    'organizer': '荒野保護協會台中分會',
    'participateNum': '1042',
    'startTime': '09/18/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.118242'
},
{
    'applyNo': '2022090800018',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118246',
    'eventName': 'WCD桃園觀音淨灘GOGO!',
    'id': 179,
    'location': '桃園市觀音草漯沙丘地質展覽館',
    'organizer': "3501地區扶少團/Let's Do It Taiwan",
    'participateNum': '40',
    'startTime': '09/18/2022 14:00:00',
    'updated': '2024-05-14 06:50:55.118249'
},
{
    'applyNo': '2022091300003',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.118252',
    'eventName': '淨灘幸福共好',
    'id': 180,
    'location': '肉粽角沙灘',
    'organizer': '台灣優格食品股份有限公司',
    'participateNum': '90',
    'startTime': '09/17/2022 08:00:00',
    'updated': '2024-05-14 06:50:55.118256'
},
{
    'applyNo': '2022091500001',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.118259',
    'eventName': '第九場公開行動',
    'id': 181,
    'location': '頭城梗枋溪出海口',
    'organizer': '海邊的接力賽',
    'participateNum': '15',
    'startTime': '09/20/2022 08:30:00',
    'updated': '2024-05-14 06:50:55.118263'
},
{
    'applyNo': '2022091500007',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118266',
    'eventName': '合隆毛廠2022 友愛海洋日',
    'id': 182,
    'location': '桃園市大園區內海許厝港',
    'organizer': '合隆毛廠股份有限公司',
    'participateNum': '40',
    'startTime': '09/22/2022 17:00:00',
    'updated': '2024-05-14 06:50:55.118269'
},
{
    'applyNo': '2022102500007',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118275',
    'eventName': '信永中和聯合會計師事務所淨灘活動',
    'id': 183,
    'location': '萬里翡翠灣',
    'organizer': '信永中和聯合會計師事務所',
    'participateNum': '40',
    'startTime': '11/25/2022 09:30:00',
    'updated': '2024-05-14 06:50:55.118279'
},
{
    'applyNo': '2022091400014',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118285',
    'eventName': '[今周刊_還海行動1095] 年度淨灘',
    'id': 184,
    'location': '八里北堤沙灘(https://goo.gl/maps/7b1YHDbmmcXTCCDx8)',
    'organizer': '主辦單位：今周刊協辦單位：海湧工作室有限公司',
    'participateNum': '250',
    'startTime': '10/02/2022 08:30:00',
    'updated': '2024-05-14 06:50:55.118288'
},
{
    'applyNo': '2022091900008',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.118292',
    'eventName': '光田 2022捲袖護地球．菸檳遠離我淨灘活動',
    'id': 185,
    'location': '龍井區海岸線',
    'organizer': '光田醫療社團法人光田綜合醫院',
    'participateNum': '150',
    'startTime': '10/22/2022 08:00:00',
    'updated': '2024-05-14 06:50:55.118295'
},
{
    'applyNo': '2022092000010',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.118298',
    'eventName': '回龜自然_720 Zero & Ocean 一袋一鏡',
    'id': 186,
    'location': '漁光島',
    'organizer': '華美光學科技股份有限公司',
    'participateNum': '250',
    'startTime': '10/22/2022 15:00:00',
    'updated': '2024-05-14 06:50:55.118302'
},
{
    'applyNo': '2022092200015',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118305',
    'eventName': 'Watermark 八里北堤沙灘',
    'id': 187,
    'location': '八里北堤沙灘',
    'organizer': 'Xylem',
    'participateNum': '4',
    'startTime': '09/30/2022 15:30:00',
    'updated': '2024-05-14 06:50:55.118308'
},
{
    'applyNo': '2022092200019',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118312',
    'eventName': '20221029後厝港 淨灘活動 (沒有志工服務時數)(沒有廁所 )',
    'id': 188,
    'location': '大園後厝港 淨灘活動',
    'organizer': '淨灘台灣淨灘顧地球Taiwan',
    'participateNum': '20',
    'startTime': '10/29/2022 08:30:00',
    'updated': '2024-05-14 06:50:55.118315'
},
{
    'applyNo': '2022092200022',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.118319',
    'eventName': '友善海洋 永續生活',
    'id': 189,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '150',
    'startTime': '10/16/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.118322'
},
{
    'applyNo': '2022092200023',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.118325',
    'eventName': '友善海洋 永續生活',
    'id': 190,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '150',
    'startTime': '11/05/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.118331'
},
{
    'applyNo': '2022092200024',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.118335',
    'eventName': '友善海洋 永續生活',
    'id': 191,
    'location': '苗栗縣後龍鎮南港漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '150',
    'startTime': '11/13/2022 10:00:00',
    'updated': '2024-05-14 06:50:55.118338'
},
{
    'applyNo': '2022092500001',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118342',
    'eventName': '20221126後厝港 淨灘活動 (沒有志工服務時數)',
    'id': 192,
    'location': '大園後厝港 ',
    'organizer': '淨灘台灣淨灘顧地球Taiwan',
    'participateNum': '20',
    'startTime': '11/26/2022 08:30:00',
    'updated': '2024-05-14 06:50:55.118345'
},
{
    'applyNo': '2022092500002',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118349',
    'eventName': '20221217後厝港 淨灘活動 (沒有志工服務時數)  (沒有廁所 )',
    'id': 193,
    'location': '後厝港 25°06\'16.7"N 121°12\'28.0"E 337桃園市大園區圳頭里',
    'organizer': '淨灘台灣淨灘顧地球Taiwan',
    'participateNum': '20',
    'startTime': '12/17/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.118352'
},
{
    'applyNo': '2022092500004',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118356',
    'eventName': '20221203觀音海水浴場淨灘活動(沒有志工服務時數)',
    'id': 194,
    'location': '觀音海水浴場25°02\'47.0"N 121°04\'26.0"E',
    'organizer': '淨灘台灣淨灘顧地球Taiwan',
    'participateNum': '20',
    'startTime': '12/03/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.118359'
},
{
    'applyNo': '2022092500005',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118362',
    'eventName': '20221119竹圍海水浴場淨灘活動 (沒有志工服務時數)',
    'id': 195,
    'location': '竹圍海水浴場 ',
    'organizer': '淨灘台灣淨灘顧地球Taiwan',
    'participateNum': '20',
    'startTime': '11/19/2022 08:30:00',
    'updated': '2024-05-14 06:50:55.118366'
},
{
    'applyNo': '2022092600001',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.118372',
    'eventName': '伸港海洋生態',
    'id': 196,
    'location': '伸港生態教育中心',
    'organizer': '洪惠全',
    'participateNum': '20',
    'startTime': '10/18/2022 15:00:00',
    'updated': '2024-05-14 06:50:55.118375'
},
{
    'applyNo': '2022092600003',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118379',
    'eventName': '【護眾生愛地球】公益淨灘',
    'id': 197,
    'location': '林口大坑站前海岸即「藍色公路海景咖啡館前海岸線」 ',
    'organizer': '淨心淨灘團 ',
    'participateNum': '30',
    'startTime': '10/05/2022 08:30:00',
    'updated': '2024-05-14 06:50:55.118382'
},
{
    'applyNo': '2022100200001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118385',
    'eventName': '沙灘慢跑淨灘活動',
    'id': 198,
    'location': '新北市貢寮金沙灣海灘',
    'organizer': '新北市馬拉松協會',
    'participateNum': '30',
    'startTime': '11/20/2022 06:30:00',
    'updated': '2024-05-14 06:50:55.118389'
},
{
    'applyNo': '2022100200003',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118392',
    'eventName': '用愛卓越愛護海洋',
    'id': 199,
    'location': '桃園市觀音區樹林至海湖段',
    'organizer': '統域領導力高階BE69',
    'participateNum': '20',
    'startTime': '10/10/2022 09:30:00',
    'updated': '2024-05-14 06:50:55.118396'
},
{
    'applyNo': '2022100300001',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118399',
    'eventName': '星球投資計畫-愛地球淨灘日',
    'id': 200,
    'location': '大園區圳股頭段',
    'organizer': '桃園嗨School',
    'participateNum': '80',
    'startTime': '10/23/2022 09:30:00',
    'updated': '2024-05-14 06:50:55.118402'
},
{
    'applyNo': '2022100300008',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.118406',
    'eventName': '自然醒-向海致淨',
    'id': 201,
    'location': '風車公園海灘',
    'organizer': '高雄領袖青年團',
    'participateNum': '25',
    'startTime': '10/29/2022 15:00:00',
    'updated': '2024-05-14 06:50:55.118410'
},
{
    'applyNo': '2022100500009',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.118413',
    'eventName': '海上與你，相約淨灘',
    'id': 202,
    'location': '伸港',
    'organizer': '烏町印製所',
    'participateNum': '5',
    'startTime': '10/10/2022 15:00:00',
    'updated': '2024-05-14 06:50:55.118416'
},
{
    'applyNo': '2022092600011',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118420',
    'eventName': '復旦高中344班來淨灘囉',
    'id': 203,
    'location': '永安漁港北岸第2段',
    'organizer': '復旦高中344第六組',
    'participateNum': '21',
    'startTime': '10/22/2022 11:00:00',
    'updated': '2024-05-14 06:50:55.118423'
},
{
    'applyNo': '2022100600008',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118427',
    'eventName': '我愛海洋',
    'id': 204,
    'location': '嘉寶沙灘',
    'organizer': '石牌玄帝宮志工組',
    'participateNum': '17',
    'startTime': '11/13/2022 08:30:00',
    'updated': '2024-05-14 06:50:55.118430'
},
{
    'applyNo': '2022100700001',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.118433',
    'eventName': '麥麥森活淨灘活動',
    'id': 205,
    'location': '西勢海堤',
    'organizer': '麥麥森活生技有限公司',
    'participateNum': '50',
    'startTime': '11/26/2022 15:00:00',
    'updated': '2024-05-14 06:50:55.118437'
},
{
    'applyNo': '2022100800001',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.118440',
    'eventName': '環保公益淨灘',
    'id': 206,
    'location': '蚵仔寮海灘',
    'organizer': '高雄市光明慈善文教協會',
    'participateNum': '40',
    'startTime': '11/06/2022 08:00:00',
    'updated': '2024-05-14 06:50:55.118444'
},
{
    'applyNo': '2022101000002',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118447',
    'eventName': '海上與你，相約淨灘',
    'id': 207,
    'location': '永安漁港',
    'organizer': '烏町印製所',
    'participateNum': '6',
    'startTime': '10/23/2022 14:30:00',
    'updated': '2024-05-14 06:50:55.118450'
},
{
    'applyNo': '2022102400006',
    'cityName': '屏東縣',
    'created': '2024-05-14 06:50:55.118454',
    'eventName': '2022',
    'id': 208,
    'location': '新園鄉共和村沙灘座標22.4753671、120.4352466',
    'organizer': '屏東縣新園鄉鹹埔仔環保協會',
    'participateNum': '30',
    'startTime': '11/06/2022 14:30:00',
    'updated': '2024-05-14 06:50:55.118457'
},
{
    'applyNo': '2022102500009',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.118463',
    'eventName': '有愛溫暖的淨灘天使',
    'id': 209,
    'location': '八斗子平浪橋',
    'organizer': '個人',
    'participateNum': '100',
    'startTime': '10/29/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.118467'
},
{
    'applyNo': '2022102500014',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118470',
    'eventName': '【護眾生愛地球】公益淨灘',
    'id': 210,
    'location': '林口大坑站前海岸即「藍色公路海景咖啡館前海岸線」',
    'organizer': '淨心淨灘團',
    'participateNum': '20',
    'startTime': '11/16/2022 08:30:00',
    'updated': '2024-05-14 06:50:55.118474'
},
{
    'applyNo': '2022102600010',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118477',
    'eventName': '龍洞大掃除',
    'id': 211,
    'location': '貢寮區龍洞社區',
    'organizer': '臺灣戶外攀岩協會',
    'participateNum': '70',
    'startTime': '10/30/2022 09:00:00',
    'updated': '2024-05-14 06:50:55.118480'
},
{
    'applyNo': '2023041100016',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118484',
    'eventName': '環保尖兵淨灘活動',
    'id': 212,
    'location': '永安漁港南岸第三段',
    'organizer': '宏致電子股份有限公司',
    'participateNum': '100',
    'startTime': '06/10/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.118487'
},
{
    'applyNo': '2023030200012',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118491',
    'eventName': '桃園市私立愛愛幼兒園~擁抱地球暨母親節淨灘活動',
    'id': 213,
    'location': '竹圍海水浴場南灘沙丘',
    'organizer': '桃園市私立愛愛幼兒園',
    'participateNum': '300',
    'startTime': '05/06/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.118494'
},
{
    'applyNo': '2023042400005',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118498',
    'eventName': "GYM灘！Let's Go",
    'id': 214,
    'location': '中角國小',
    'organizer': 'Vast',
    'participateNum': '100',
    'startTime': '05/06/2023 10:30:00',
    'updated': '2024-05-14 06:50:55.118501'
},
{
    'applyNo': '2023042500004',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118505',
    'eventName': 'SALT BEACH CLEAN UP',
    'id': 215,
    'location': '萬里頂寮海灘',
    'organizer': 'SALT Collectiv',
    'participateNum': '80',
    'startTime': '05/27/2023 08:30:00',
    'updated': '2024-05-14 06:50:55.118511'
},
{
    'applyNo': '2023042500011',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.118514',
    'eventName': '淨灘小戰隊',
    'id': 216,
    'location': '清水區一段海岸線',
    'organizer': '個人申請-張蕙晴',
    'participateNum': '8',
    'startTime': '05/07/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.118518'
},
{
    'applyNo': '2023042500008',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.118521',
    'eventName': '友善海洋 永續生活',
    'id': 217,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '200',
    'startTime': '05/20/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.118525'
},
{
    'applyNo': '2023052200005',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118528',
    'eventName': '海龜不哭交友淨灘',
    'id': 218,
    'location': '野柳漁港旁的岩岸',
    'organizer': '海龜不哭',
    'participateNum': '100',
    'startTime': '06/25/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.118532'
},
{
    'applyNo': '2023042000013',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118535',
    'eventName': 'everrich1%海岸線認養計畫-下社海灘全段海岸',
    'id': 219,
    'location': '下社海灘全段海岸',
    'organizer': '昇恆昌股份有限公司',
    'participateNum': '40',
    'startTime': '05/27/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.118538'
},
{
    'applyNo': '2023051900008',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.118542',
    'eventName': '海好有你 淨栗守護海洋',
    'id': 220,
    'location': '新埔海堤',
    'organizer': '舜程創意行銷有限公司',
    'participateNum': '50',
    'startTime': '06/04/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.118545'
},
{
    'applyNo': '2023052200007',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118549',
    'eventName': '海龜不哭X國柱聯合淨灘',
    'id': 221,
    'location': '觀音海水浴場',
    'organizer': '海龜不哭/國柱',
    'participateNum': '100',
    'startTime': '10/28/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.118552'
},
{
    'applyNo': '2023060100022',
    'cityName': '花蓮縣',
    'created': '2024-05-14 06:50:55.118558',
    'eventName': '親淨洄瀾-壽豐鄉鹽寮海岸淨灘',
    'id': 222,
    'location': '鹽寮海岸',
    'organizer': '高雄醫學大學 國際志工社',
    'participateNum': '67',
    'startTime': '07/10/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.118561'
},
{
    'applyNo': '2023042400011',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.118565',
    'eventName': '等待淨灘',
    'id': 223,
    'location': '基隆外木山龍蝦麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '25',
    'startTime': '05/07/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.118568'
},
{
    'applyNo': '2023042100005',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118572',
    'eventName': "【GYM灘！Let's Go】和Vast一起去Gym灘～ ",
    'id': 224,
    'location': '金山中角海灘',
    'organizer': 'Vast',
    'participateNum': '80',
    'startTime': '05/06/2023 10:30:00',
    'updated': '2024-05-14 06:50:55.118575'
},
{
    'applyNo': '2023032200007',
    'cityName': '新竹市',
    'created': '2024-05-14 06:50:55.118578',
    'eventName': '校園永續淨灘',
    'id': 225,
    'location': '金城湖外圍沙灘',
    'organizer': '國立陽明交通大學人社系學會 ',
    'participateNum': '15',
    'startTime': '04/29/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.118582'
},
{
    'applyNo': '2023042800009',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.118585',
    'eventName': '手牽手EYE海洋淨灘',
    'id': 226,
    'location': '基隆外木山龍蝦麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '20',
    'startTime': '05/04/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.118588'
},
{
    'applyNo': '2023042800013',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118592',
    'eventName': '2023年逆風聯隊公益淨灘車聚',
    'id': 227,
    'location': '新北市萬里區大鵬里聖安宮入口進入下寮海灘入口處',
    'organizer': '社團法人台灣風啟青少年賦歸協會',
    'participateNum': '100',
    'startTime': '06/03/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.118595'
},
{
    'applyNo': '2023043000006',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118599',
    'eventName': '白沙灣淨灘團的LINE',
    'id': 228,
    'location': '新北市石門白沙灣',
    'organizer': '淨灘團的LINE',
    'participateNum': '100',
    'startTime': '05/27/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.118602'
},
{
    'applyNo': '2023042600005',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.118605',
    'eventName': '2023 RE-THINK x KIRIN 台中清水淨灘',
    'id': 229,
    'location': '海角明珠',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '300',
    'startTime': '05/13/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.118609'
},
{
    'applyNo': '2023043000003',
    'cityName': '屏東縣',
    'created': '2024-05-14 06:50:55.118612',
    'eventName': '2023南國生活節｜國淨之南｜淨灘活動',
    'id': 230,
    'location': '萬里桐海灘',
    'organizer': 'LA RUE文創設計',
    'participateNum': '50',
    'startTime': '05/26/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.118616'
},
{
    'applyNo': '2023041700009',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.118619',
    'eventName': '2023 BIG BLUE淨灘總動員',
    'id': 231,
    'location': '旗津貝殼博物館海岸',
    'organizer': '慈心有機農業發展基金會',
    'participateNum': '300',
    'startTime': '',
    'updated': '2024-05-14 06:50:55.118622'
},
{
    'applyNo': '2023050300013',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.118626',
    'eventName': '黃金海岸淨灘',
    'id': 232,
    'location': '台南市黃金海岸',
    'organizer': '台南大學附中114班男生',
    'participateNum': '14',
    'startTime': '05/08/2023 11:00:00',
    'updated': '2024-05-14 06:50:55.118629'
},
{
    'applyNo': '2023050300007',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118633',
    'eventName': '2023 ESG環境永續-綠色環境志工服務',
    'id': 233,
    'location': '桃園大園竹圍段',
    'organizer': '和潤企業股份有限公司 企業金融部',
    'participateNum': '60',
    'startTime': '05/27/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.118637'
},
{
    'applyNo': '2023050700002',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118640',
    'eventName': 'Mister Friendship 淨灘',
    'id': 234,
    'location': '金沙灣海濱公園',
    'organizer': 'Mister Friendship Taiwan',
    'participateNum': '15',
    'startTime': '08/05/2023 14:30:00',
    'updated': '2024-05-14 06:50:55.118643'
},
{
    'applyNo': '2023050300010',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118649',
    'eventName': '《還海行動1095》潛海戰將，百人淨灘淨海活動',
    'id': 235,
    'location': '龍洞灣',
    'organizer': '海湧工作室',
    'participateNum': '80',
    'startTime': '05/27/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.118653'
},
{
    'applyNo': '2023050900007',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118656',
    'eventName': '凱基證券人資淨灘志工活動',
    'id': 236,
    'location': '淡水沙崙海灘',
    'organizer': '凱基證券人力資源部',
    'participateNum': '20',
    'startTime': '06/17/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.118660'
},
{
    'applyNo': '2023050900008',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.118663',
    'eventName': '5/21淨灘',
    'id': 237,
    'location': '海角明珠',
    'organizer': '個人號召',
    'participateNum': '6',
    'startTime': '05/21/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.118667'
},
{
    'applyNo': '2023050300008',
    'cityName': '新竹市',
    'created': '2024-05-14 06:50:55.118670',
    'eventName': '海洋不吃塑',
    'id': 238,
    'location': '南港賞鳥區',
    'organizer': '個人申請',
    'participateNum': '35',
    'startTime': '05/20/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.118673'
},
{
    'applyNo': '2023051000008',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.118677',
    'eventName': '作似休三淨灘',
    'id': 239,
    'location': '基隆外木山龍蝦麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '5',
    'startTime': '05/19/2023 07:00:00',
    'updated': '2024-05-14 06:50:55.118680'
},
{
    'applyNo': '2023050800003',
    'cityName': '新竹市',
    'created': '2024-05-14 06:50:55.118683',
    'eventName': '南寮魚鱗天梯淨灘活動',
    'id': 240,
    'location': '南寮漁港，南寮魚鱗天梯',
    'organizer': '吉田開發建設有限公司',
    'participateNum': '25',
    'startTime': '06/17/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.118690'
},
{
    'applyNo': '2023051500001',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.118694',
    'eventName': '愛地球',
    'id': 241,
    'location': '南莊海提11號風車',
    'organizer': '美尼亞國際有限公司',
    'participateNum': '50',
    'startTime': '06/04/2023 07:00:00',
    'updated': '2024-05-14 06:50:55.118697'
},
{
    'applyNo': '2023053000003',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.118701',
    'eventName': '友善海洋 永續生活',
    'id': 242,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '200',
    'startTime': '06/17/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.118704'
},
{
    'applyNo': '2023060400008',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118707',
    'eventName': '一起來淨灘',
    'id': 243,
    'location': '三芝區牛車寮海灘(淺水灣左邊沙灘)',
    'organizer': '個人團體',
    'participateNum': '60',
    'startTime': '07/22/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.118711'
},
{
    'applyNo': '2023050900014',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118714',
    'eventName': '2023星球投資計畫🌏 青年出任務！淨灘啦!',
    'id': 244,
    'location': '新屋區永安漁港南岸第四段',
    'organizer': '桃園嗨School',
    'participateNum': '40',
    'startTime': '05/28/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.118717'
},
{
    'applyNo': '2023050600006',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.118721',
    'eventName': '回復藍碳，復興我們的海洋',
    'id': 245,
    'location': '海洋光廊靠近',
    'organizer': '上帝的教會世界福音宣教協會',
    'participateNum': '60',
    'startTime': '06/04/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.118724'
},
{
    'applyNo': '2023051600010',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.118728',
    'eventName': '6/10  Remove ~『蚵仔寮』淨灘行動',
    'id': 246,
    'location': '梓官-蚵仔寮沙灘',
    'organizer': '個人-黃立嘉(Remove Waste守護者行動)',
    'participateNum': '30',
    'startTime': '06/10/2023 13:30:00',
    'updated': '2024-05-14 06:50:55.118731'
},
{
    'applyNo': '2023051600001',
    'cityName': '臺東縣',
    'created': '2024-05-14 06:50:55.118737',
    'eventName': '池上國中淨灘活動',
    'id': 247,
    'location': '海濱公園',
    'organizer': '臺東縣立池上國民中學',
    'participateNum': '80',
    'startTime': '06/07/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.118740'
},
{
    'applyNo': '2023051800001',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.118746',
    'eventName': '第25場列行動',
    'id': 248,
    'location': '梗枋更新全家便利商店',
    'organizer': '海邊的接力賽',
    'participateNum': '15',
    'startTime': '05/20/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.118749'
},
{
    'applyNo': '2023050900010',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.118753',
    'eventName': '橙心國際企業有限公司',
    'id': 249,
    'location': '大安濱海樂園沙灘戲水區',
    'organizer': '橙心國際企業有限公司',
    'participateNum': '9',
    'startTime': '06/17/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.118756'
},
{
    'applyNo': '2023051700012',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.118760',
    'eventName': '我要去淨灘',
    'id': 250,
    'location': '南埔簡易棒壘球場旁海岸',
    'organizer': '臺中市蔬食台灣促進會',
    'participateNum': '50',
    'startTime': '06/23/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.118763'
},
{
    'applyNo': '2023052200013',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118766',
    'eventName': '6/10金沙灣海灘淨灘',
    'id': 251,
    'location': '金沙灣海灘',
    'organizer': '凱基證券行政管理部',
    'participateNum': '60',
    'startTime': '06/10/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.118770'
},
{
    'applyNo': '2023051500011',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.118773',
    'eventName': '環保公益淨灘',
    'id': 252,
    'location': '蚵仔寮海灘',
    'organizer': '高雄市光明慈善文教協會',
    'participateNum': '20',
    'startTime': '05/27/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.118777'
},
{
    'applyNo': '2023052300010',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.118780',
    'eventName': '正能量手護海洋',
    'id': 253,
    'location': '基隆外木山（私人島嶼Mykano前海灘）',
    'organizer': '財團法人釋迦牟尼佛救世基金會(基隆禪宗印心會館)',
    'participateNum': '100',
    'startTime': '09/09/2023 06:30:00',
    'updated': '2024-05-14 06:50:55.118783'
},
{
    'applyNo': '2023052200015',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118787',
    'eventName': '新北愛地球-環保淨灘活動',
    'id': 254,
    'location': '新北沙崙海灘',
    'organizer': '青年共創發展協會',
    'participateNum': '30',
    'startTime': '06/03/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.118790'
},
{
    'applyNo': '2023052300004',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118794',
    'eventName': '淨灘flow me',
    'id': 255,
    'location': '林口區嘉寶沙灘(第一座風車)',
    'organizer': '華碩電腦股份有限公司',
    'participateNum': '100',
    'startTime': '06/17/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.118797'
},
{
    'applyNo': '2023052400017',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.118800',
    'eventName': '2023沛納海海洋保育校園行動-淨灘競賽活動',
    'id': 256,
    'location': '外木山海岸',
    'organizer': '海湧工作室有限公司',
    'participateNum': '100',
    'startTime': '06/11/2023 10:30:00',
    'updated': '2024-05-14 06:50:55.118804'
},
{
    'applyNo': '2023052500012',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118808',
    'eventName': '夏季淨灘',
    'id': 257,
    'location': '林口應公坑站前海灘段一',
    'organizer': '無極祖敕鴻元殿',
    'participateNum': '10',
    'startTime': '06/18/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.118811'
},
{
    'applyNo': '2023052500001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118815',
    'eventName': '淨灘活動',
    'id': 258,
    'location': '淡水沙崙沙灘',
    'organizer': '卡朵',
    'participateNum': '40',
    'startTime': '06/18/2023 14:30:00',
    'updated': '2024-05-14 06:50:55.118818'
},
{
    'applyNo': '2023053000004',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.118821',
    'eventName': '友善海洋 永續生活',
    'id': 259,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '200',
    'startTime': '07/23/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.118825'
},
{
    'applyNo': '2023060500003',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.118828',
    'eventName': '淨灘活動',
    'id': 260,
    'location': '高美濕地',
    'organizer': '海聲華德福教育學會',
    'participateNum': '144',
    'startTime': '06/07/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.118832'
},
{
    'applyNo': '2023060400007',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118837',
    'eventName': '新北市石門白沙灣淨灘',
    'id': 261,
    'location': '白沙灣遊客中心(新北市石門區德茂里下員坑33-6號）',
    'organizer': '淨灘團的LINE',
    'participateNum': '100',
    'startTime': '06/24/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.118841'
},
{
    'applyNo': '2023060500002',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118844',
    'eventName': '搶救海龜大作戰',
    'id': 262,
    'location': '淡水六塊海岸',
    'organizer': '達步施企業股份有限公司',
    'participateNum': '50',
    'startTime': '06/17/2023 13:30:00',
    'updated': '2024-05-14 06:50:55.118848'
},
{
    'applyNo': '2023061300004',
    'cityName': '花蓮縣',
    'created': '2024-05-14 06:50:55.118851',
    'eventName': '2023TKIJIG得吉利黃金海岸生活節',
    'id': 263,
    'location': '海巡署崇德安檢所旁場域(秀林鄉崇德村轄內)',
    'organizer': '花蓮縣秀林鄉公所/翌暘工程顧問有限公司',
    'participateNum': '4',
    'startTime': '08/05/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.118854'
},
{
    'applyNo': '2023061700003',
    'cityName': '臺東縣',
    'created': '2024-05-14 06:50:55.118858',
    'eventName': '迎接日出 揮別無塑',
    'id': 264,
    'location': '達仁鄉南田海岸親水公園',
    'organizer': '臺東縣環境保護局',
    'participateNum': '70',
    'startTime': '06/18/2023 05:00:00',
    'updated': '2024-05-14 06:50:55.118861'
},
{
    'applyNo': '2023061400001',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.118865',
    'eventName': '搶救海洋大作戰~',
    'id': 265,
    'location': '台中市清水區1段',
    'organizer': '林小佐',
    'participateNum': '3',
    'startTime': '07/28/2023 15:30:00',
    'updated': '2024-05-14 06:50:55.118876'
},
{
    'applyNo': '2023062000006',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.118879',
    'eventName': 'RE-THINK 2023 環島淨灘 遶境護海洋！',
    'id': 266,
    'location': '青山港沙洲',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '350',
    'startTime': '08/06/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.118883'
},
{
    'applyNo': '2023062000007',
    'cityName': '花蓮縣',
    'created': '2024-05-14 06:50:55.118886',
    'eventName': 'RE-THINK 2023 環島淨灘 遶境護海洋！',
    'id': 267,
    'location': '康樂泊區',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '250',
    'startTime': '08/19/2023 15:30:00',
    'updated': '2024-05-14 06:50:55.118889'
},
{
    'applyNo': '2023062100002',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118893',
    'eventName': '海深之處 無塑BLUE',
    'id': 268,
    'location': '小野柳跟石角海灘區',
    'organizer': '財團法人基督教芥菜種會',
    'participateNum': '100',
    'startTime': '09/08/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.118896'
},
{
    'applyNo': '2023062500001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118900',
    'eventName': '【護眾生愛地球】公益淨灘',
    'id': 269,
    'location': '林口瑞平國小前海岸',
    'organizer': '淨心淨灘團',
    'participateNum': '30',
    'startTime': '07/15/2023 08:30:00',
    'updated': '2024-05-14 06:50:55.118903'
},
{
    'applyNo': '2023062100003',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.118907',
    'eventName': '新北市游氏宗親會112年社會公益暨宗親交流',
    'id': 270,
    'location': '壯圍鄉東港地段海岸',
    'organizer': '新北市游氏宗親會',
    'participateNum': '35',
    'startTime': '07/03/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.118910'
},
{
    'applyNo': '2023062000003',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.118914',
    'eventName': 'RE-THINK 2023 環島淨灘 遶境護海洋！',
    'id': 271,
    'location': '台中南埔海堤',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '400',
    'startTime': '07/22/2023 16:00:00',
    'updated': '2024-05-14 06:50:55.118917'
},
{
    'applyNo': '2023062000004',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.118921',
    'eventName': 'RE-THINK 2023 環島淨灘 遶境護海洋！',
    'id': 272,
    'location': '風車聚落',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '350',
    'startTime': '07/23/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.118924'
},
{
    'applyNo': '2023072700001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118927',
    'eventName': 'GEMS-Taiwan Beach Cleanup 2023',
    'id': 273,
    'location': '三芝沙崙湖',
    'organizer': 'GEMS-Taiwan',
    'participateNum': '85',
    'startTime': '08/14/2023 11:00:00',
    'updated': '2024-05-14 06:50:55.118931'
},
{
    'applyNo': '2023053100002',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.118937',
    'eventName': '第26場公開行動',
    'id': 274,
    'location': '外澳金斗公廟',
    'organizer': '海邊的接力賽',
    'participateNum': '10',
    'startTime': '06/27/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.118941'
},
{
    'applyNo': '2023062000001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118944',
    'eventName': 'RE-THINK 2023 環島淨灘 遶境護海洋！',
    'id': 275,
    'location': '卯澳漁港',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '450',
    'startTime': '07/15/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.118947'
},
{
    'applyNo': '2023062000002',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118951',
    'eventName': 'RE-THINK 2023 環島淨灘 遶境護海洋！',
    'id': 276,
    'location': '十八王公廟旁海岸',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '300',
    'startTime': '07/16/2023 15:30:00',
    'updated': '2024-05-14 06:50:55.118954'
},
{
    'applyNo': '2023070200001',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.118958',
    'eventName': '清淨家園淨灘活動',
    'id': 277,
    'location': '鹿港新崙尾海堤1號至6號防波突堤海岸直接面對台灣海峽，每月總有大量海漂垃圾聚積於此。',
    'organizer': '彰化縣大地保護協會',
    'participateNum': '40',
    'startTime': '08/20/2023 08:30:00',
    'updated': '2024-05-14 06:50:55.118961'
},
{
    'applyNo': '2023070300003',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.118965',
    'eventName': '國眾電腦來淨灘',
    'id': 278,
    'location': '基隆外木山龍蝦麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '40',
    'startTime': '08/26/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.118968'
},
{
    'applyNo': '2023070300002',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.118971',
    'eventName': '夏日淘寶淨灘',
    'id': 279,
    'location': '基隆外木山龍蝦麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '20',
    'startTime': '07/16/2023 15:30:00',
    'updated': '2024-05-14 06:50:55.118983'
},
{
    'applyNo': '2023070200002',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118985',
    'eventName': '醫檢師愛地球不缺席',
    'id': 280,
    'location': '淡水六塊厝沙灘',
    'organizer': '新北市醫事檢驗師公會',
    'participateNum': '20',
    'startTime': '07/09/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.118985'
},
{
    'applyNo': '2023062900006',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.118993',
    'eventName': '海龜不哭交友淨灘',
    'id': 281,
    'location': '萬里海水浴場',
    'organizer': '海龜不哭',
    'participateNum': '100',
    'startTime': '07/29/2023 16:00:00',
    'updated': '2024-05-14 06:50:55.118993'
},
{
    'applyNo': '2023063000004',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.118993',
    'eventName': '光寶大園淨灘維護家園',
    'id': 282,
    'location': '竹圍漁港附近海水浴場沙灘區(步行至漁會約 2 分鐘)',
    'organizer': '光寶科技股份有限公司大園廠社團(野狼幫露營社)',
    'participateNum': '50',
    'startTime': '10/21/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.119004'
},
{
    'applyNo': '2023081600005',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.119007',
    'eventName': '夏日淘寶淨灘',
    'id': 283,
    'location': '基隆外木山龍蝦麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '10',
    'startTime': '09/02/2023 05:30:00',
    'updated': '2024-05-14 06:50:55.119011'
},
{
    'applyNo': '2023070600010',
    'cityName': '屏東縣',
    'created': '2024-05-14 06:50:55.119013',
    'eventName': '與海的約定',
    'id': 284,
    'location': '恆春萬里桐海域',
    'organizer': '社團法人南投縣蒙愛家庭關懷協會',
    'participateNum': '25',
    'startTime': '07/19/2023 11:30:00',
    'updated': '2024-05-14 06:50:55.119013'
},
{
    'applyNo': '2023070400001',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.119013',
    'eventName': '草漯沙丘環境教育體驗課程：清淨沙丘',
    'id': 285,
    'location': '觀音白沙屯觀景步道',
    'organizer': '禾大國際管理顧問股份有限公司',
    'participateNum': '60',
    'startTime': '07/22/2023 07:00:00',
    'updated': '2024-05-14 06:50:55.119016'
},
{
    'applyNo': '2023070300001',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.119019',
    'eventName': '8/5  Remove ~『旗津』淨灘行動',
    'id': 286,
    'location': '旗津海水浴場',
    'organizer': '個人-黃立嘉(Remove Waste守護者行動)',
    'participateNum': '35',
    'startTime': '07/29/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.119023'
},
{
    'applyNo': '2023070500002',
    'cityName': '新竹縣',
    'created': '2024-05-14 06:50:55.119029',
    'eventName': '環保淨灘',
    'id': 287,
    'location': '新月沙灣',
    'organizer': '國泰人壽竹北J區',
    'participateNum': '20',
    'startTime': '07/15/2023 16:00:00',
    'updated': '2024-05-14 06:50:55.119032'
},
{
    'applyNo': '2023070400004',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119035',
    'eventName': 'Vespa 摩德士淨灘小跑\u200b',
    'id': 288,
    'location': '金山豐漁(水尾)漁港停車場前海岸',
    'organizer': '摩德士國際有限公司',
    'participateNum': '12',
    'startTime': '08/13/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.119039'
},
{
    'applyNo': '2023070600011',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.119042',
    'eventName': '台灣基督長老教會台南中會教社部淨灘活動',
    'id': 289,
    'location': '觀夕平台',
    'organizer': '財團法人台灣基督長老教會台南中會',
    'participateNum': '200',
    'startTime': '09/24/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.119046'
},
{
    'applyNo': '2023070700005',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119049',
    'eventName': '金山水尾漁港淨灘！揪團一起GO！',
    'id': 290,
    'location': '金山水尾漁港',
    'organizer': '社團法人寶島淨鄉團',
    'participateNum': '150',
    'startTime': '07/29/2023 14:30:00',
    'updated': '2024-05-14 06:50:55.119055'
},
{
    'applyNo': '2023070500005',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.119058',
    'eventName': '8/5  Remove ~『旗津』淨灘行動',
    'id': 291,
    'location': '旗津海水浴場',
    'organizer': '個人-黃立嘉(Remove Waste守護者行動)',
    'participateNum': '36',
    'startTime': '08/05/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.119062'
},
{
    'applyNo': '2023070300005',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.119065',
    'eventName': '環保公益淨灘',
    'id': 292,
    'location': '蚵仔寮海灘',
    'organizer': '高雄市光明慈善文教協會',
    'participateNum': '25',
    'startTime': '08/06/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.119068'
},
{
    'applyNo': '2023071100009',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119072',
    'eventName': 'Taiwan National Clean Up',
    'id': 293,
    'location': '新北市下寮海灘',
    'organizer': '景躍實業股份有限公司',
    'participateNum': '30',
    'startTime': '08/19/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.119075'
},
{
    'applyNo': '2023071200010',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.119079',
    'eventName': '112年度減塑淨灘17GO',
    'id': 294,
    'location': '竹南長青之森出海口',
    'organizer': '裕鼎股份有限公司',
    'participateNum': '180',
    'startTime': '08/12/2023 08:30:00',
    'updated': '2024-05-14 06:50:55.119082'
},
{
    'applyNo': '2023071200002',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.119086',
    'eventName': '第29場公開行動',
    'id': 295,
    'location': '南澳朝陽漁港北堤沙灘',
    'organizer': '海邊的接力賽',
    'participateNum': '10',
    'startTime': '07/18/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.119089'
},
{
    'applyNo': '2023071100012',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.119093',
    'eventName': '淨灘i地球 撿塑大行動',
    'id': 296,
    'location': '大武崙白沙灘',
    'organizer': 'iFG遠雄廣場',
    'participateNum': '80',
    'startTime': '09/17/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.119096'
},
{
    'applyNo': '2023071100010',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.119100',
    'eventName': '2023國際淨灘行動-沒塑去旅行-台中場0924',
    'id': 297,
    'location': '台中市大甲區松柏與港北邊船頭埔海堤與南邊西勢海堤',
    'organizer': '荒野保護協會台中分會',
    'participateNum': '1000',
    'startTime': '09/24/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.119103'
},
{
    'applyNo': '2023071100014',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.119107',
    'eventName': '淨灘i地球 撿塑大行動',
    'id': 298,
    'location': '大武崙白沙灘',
    'organizer': 'iFG遠雄廣場',
    'participateNum': '80',
    'startTime': '09/16/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.119110'
},
{
    'applyNo': '2023071200007',
    'cityName': '花蓮縣',
    'created': '2024-05-14 06:50:55.119113',
    'eventName': '「淨灘星潭 永續未來」活動',
    'id': 299,
    'location': '花蓮七星潭賞星廣場',
    'organizer': '中華民國護理師護士公會全國聯合會',
    'participateNum': '200',
    'startTime': '09/02/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.119117'
},
{
    'applyNo': '2023071300003',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.119123',
    'eventName': '日出防曬淨灘',
    'id': 300,
    'location': '基隆大武崙沙灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '10',
    'startTime': '07/23/2023 05:00:00',
    'updated': '2024-05-14 06:50:55.119126'
},
{
    'applyNo': '2023071800001',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.119130',
    'eventName': '海湧x碩隆精密工業 8/5 大園沙崙淨灘活動！',
    'id': 301,
    'location': '大園沙崙海灘',
    'organizer': '海湧工作室',
    'participateNum': '100',
    'startTime': '08/05/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.119133'
},
{
    'applyNo': '2023071700006',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119136',
    'eventName': '新鈺生技企業淨灘活動-中角灣',
    'id': 302,
    'location': '金山區中角灣',
    'organizer': '新鈺生技股份有限公司',
    'participateNum': '20',
    'startTime': '08/25/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.119140'
},
{
    'applyNo': '2023071400005',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.119143',
    'eventName': 'save the ocean together',
    'id': 303,
    'location': '松柏港北提沙灘',
    'organizer': '金芯國際有限公司',
    'participateNum': '50',
    'startTime': '08/13/2023 13:30:00',
    'updated': '2024-05-14 06:50:55.119147'
},
{
    'applyNo': '2023071800004',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119150',
    'eventName': '愛海小旅行-淨灘活動',
    'id': 304,
    'location': '萬里下寮海灘(下社海灘)',
    'organizer': '恆隆行貿易股份有限公司',
    'participateNum': '12',
    'startTime': '08/05/2023 11:00:00',
    'updated': '2024-05-14 06:50:55.119153'
},
{
    'applyNo': '2023071400006',
    'cityName': '新竹市',
    'created': '2024-05-14 06:50:55.119157',
    'eventName': '法務部行政執行署新竹分署中秋公益淨灘活動',
    'id': 305,
    'location': '幸福沙灘',
    'organizer': '法務部行政執行署新竹分署',
    'participateNum': '30',
    'startTime': '09/08/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.119160'
},
{
    'applyNo': '2023071800002',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.119164',
    'eventName': '8/6 世界牡蠣日 彰化芳苑淨灘活動！',
    'id': 306,
    'location': '芳苑新寶海堤',
    'organizer': '海湧工作室',
    'participateNum': '100',
    'startTime': '08/06/2023 16:00:00',
    'updated': '2024-05-14 06:50:55.119167'
},
{
    'applyNo': '2023072000011',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.119170',
    'eventName': '夏日淘寶淨灘',
    'id': 307,
    'location': '基隆外木山龍蝦麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '20',
    'startTime': '08/06/2023 15:30:00',
    'updated': '2024-05-14 06:50:55.119174'
},
{
    'applyNo': '2023072300001',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.119177',
    'eventName': '中部淨灘趣',
    'id': 308,
    'location': '夕陽關照的蝦猴保育區',
    'organizer': '洪惠全',
    'participateNum': '20',
    'startTime': '08/26/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.119181'
},
{
    'applyNo': '2023072100004',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.119184',
    'eventName': '淨灘海岸 幸福共好',
    'id': 309,
    'location': '彰化縣線西鄉肉粽角沙灘',
    'organizer': '台灣優格食品股份有限公司',
    'participateNum': '100',
    'startTime': '07/22/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.119188'
},
{
    'applyNo': '2023072100001',
    'cityName': '屏東縣',
    'created': '2024-05-14 06:50:55.119199',
    'eventName': '2023國際淨灘日-聯合淨灘活動',
    'id': 310,
    'location': '屏東縣琉球鄉-中澳沙灘',
    'organizer': '澎坊股份有限公司（小琉球免稅商店）',
    'participateNum': '60',
    'startTime': '09/16/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.119202'
},
{
    'applyNo': '2023070400007',
    'cityName': '新竹市',
    'created': '2024-05-14 06:50:55.119206',
    'eventName': '【2023國際淨灘行動】愛海無ㄐㄩˋ──沒塑去旅行',
    'id': 311,
    'location': '南寮漁港觀音亭北岸',
    'organizer': '荒野保護協會新竹分會',
    'participateNum': '600',
    'startTime': '09/16/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.119210'
},
{
    'applyNo': '2023072500003',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119213',
    'eventName': '0916響應LDI世界環境清潔日',
    'id': 312,
    'location': '一個充滿人文、文化、景色優美，但遭受海洋垃圾污染的地方',
    'organizer': 'J4U志工團',
    'participateNum': '75',
    'startTime': '09/16/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.119216'
},
{
    'applyNo': '2023080600004',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.119222',
    'eventName': '友善海洋 永續生活',
    'id': 313,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '200',
    'startTime': '10/15/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.119226'
},
{
    'applyNo': '2023080400001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119229',
    'eventName': '海龜不哭交友淨灘',
    'id': 314,
    'location': '萬里海水浴場',
    'organizer': '海龜不哭',
    'participateNum': '100',
    'startTime': '08/26/2023 16:00:00',
    'updated': '2024-05-14 06:50:55.119232'
},
{
    'applyNo': '2023080700006',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119236',
    'eventName': '國泰世華商業銀行八里北堤淨灘活動',
    'id': 315,
    'location': '八里北堤沙灘',
    'organizer': '國泰世華商業銀行',
    'participateNum': '80',
    'startTime': '11/04/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.119242'
},
{
    'applyNo': '2023080700002',
    'cityName': '臺東縣',
    'created': '2024-05-14 06:50:55.119252',
    'eventName': '海洋偵探團｜海洋公民科學推廣與實作',
    'id': 316,
    'location': '漂流木石滬沙灘(https://goo.gl/maps/2JUpMQgDxvy59Rr19)',
    'organizer': '海洋保育署第十工作站',
    'participateNum': '45',
    'startTime': '08/13/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.119255'
},
{
    'applyNo': '2023080600003',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.119259',
    'eventName': '友善海洋 永續生活',
    'id': 317,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '200',
    'startTime': '09/17/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.119262'
},
{
    'applyNo': '2023082900004',
    'cityName': '新竹縣',
    'created': '2024-05-14 06:50:55.119266',
    'eventName': '2023 RE-THINK x 芯科實驗室 新竹鳳坑淨灘',
    'id': 318,
    'location': '新竹鳳坑漁港',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '250',
    'startTime': '10/04/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.119271'
},
{
    'applyNo': '2023072700002',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.119274',
    'eventName': '熊熊想上陸-淨灘活動',
    'id': 319,
    'location': '大武崙澳底海灘',
    'organizer': '綿春纖維工業股份有限公司',
    'participateNum': '120',
    'startTime': '09/23/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.119278'
},
{
    'applyNo': '2023080100005',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119281',
    'eventName': '沒塑去旅行│2023 國際淨灘行動_0916台北場',
    'id': 320,
    'location': '乾華十八王公廟旁濱海公路下方',
    'organizer': '社團法人中華民國荒野保護協會',
    'participateNum': '400',
    'startTime': '09/16/2023 12:00:00',
    'updated': '2024-05-14 06:50:55.119285'
},
{
    'applyNo': '2023081000003',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.119288',
    'eventName': '友善海洋 永續生活',
    'id': 321,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '200',
    'startTime': '08/26/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.119292'
},
{
    'applyNo': '2023081000004',
    'cityName': '屏東縣',
    'created': '2024-05-14 06:50:55.119295',
    'eventName': 'RE-THINK 2023 環島淨灘 遶境護海洋！',
    'id': 322,
    'location': '新園轄內海岸灘',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '300',
    'startTime': '08/26/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.119298'
},
{
    'applyNo': '2023080800011',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.119302',
    'eventName': '搶救海洋大作戰~',
    'id': 323,
    'location': '台中市大安區龜殼生態公園的海岸線',
    'organizer': '林小佐',
    'participateNum': '10',
    'startTime': '09/15/2023 15:30:00',
    'updated': '2024-05-14 06:50:55.119305'
},
{
    'applyNo': '2023081200003',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119309',
    'eventName': '撿拾環淨 公益淨灘活動 ',
    'id': 324,
    'location': '林口應公坑站前海灘段一',
    'organizer': '無極祖敕鴻元殿',
    'participateNum': '10',
    'startTime': '09/03/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.119312'
},
{
    'applyNo': '2023080800008',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.119316',
    'eventName': '姐姐妹妹攜手護家園',
    'id': 325,
    'location': '蚵仔寮南沙灘',
    'organizer': '舒緹國際蘭馨交流協會',
    'participateNum': '40',
    'startTime': '08/27/2023 08:30:00',
    'updated': '2024-05-14 06:50:55.119319'
},
{
    'applyNo': '2023081000006',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.119325',
    'eventName': '2023 RE-THINK x KIRIN 苗栗外埔淨灘',
    'id': 326,
    'location': '外埔漁港北堤',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '300',
    'startTime': '09/09/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.119328'
},
{
    'applyNo': '2023081000005',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119332',
    'eventName': '2023 RE-THINK x ORIS 新北三芝淨灘',
    'id': 327,
    'location': '三芝大田寮停車場',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '350',
    'startTime': '09/16/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.119335'
},
{
    'applyNo': '2023081600010',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119339',
    'eventName': '0916老梅淨灘活動 ',
    'id': 328,
    'location': '老梅海岸+風箏公園海岸',
    'organizer': '昇恆昌(股)公司',
    'participateNum': '60',
    'startTime': '09/16/2023 08:30:00',
    'updated': '2024-05-14 06:50:55.119342'
},
{
    'applyNo': '2023081600008',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119345',
    'eventName': '0916老梅淨灘活動 ',
    'id': 329,
    'location': '老梅海岸+風箏公園海岸',
    'organizer': '昇恆昌(股)公司',
    'participateNum': '100',
    'startTime': '09/16/2023 08:30:00',
    'updated': '2024-05-14 06:50:55.119349'
},
{
    'applyNo': '2023081800017',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.119352',
    'eventName': '台南淨遊趣淨灘',
    'id': 330,
    'location': '四草大橋下方，鹽水溪北岸',
    'organizer': '台南淨遊趣',
    'participateNum': '120',
    'startTime': '09/16/2023 16:00:00',
    'updated': '2024-05-14 06:50:55.119356'
},
{
    'applyNo': '2023080900009',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.119359',
    'eventName': '環保公益淨灘',
    'id': 331,
    'location': '蚵仔寮海灘',
    'organizer': '高雄市光明慈善文教協會',
    'participateNum': '30',
    'startTime': '09/03/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.119362'
},
{
    'applyNo': '2023081400006',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.119366',
    'eventName': '9/16  Remove ~『蚵仔寮』淨灘行動',
    'id': 332,
    'location': '梓官-蚵仔寮沙灘',
    'organizer': '個人-黃立嘉(Remove Waste守護者行動)',
    'participateNum': '35',
    'startTime': '09/16/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.119369'
},
{
    'applyNo': '2023081600007',
    'cityName': '新竹市',
    'created': '2024-05-14 06:50:55.119373',
    'eventName': '2023勝高SUMCO Ocean Cleaning',
    'id': 333,
    'location': '看海公園',
    'organizer': '台灣勝高科技股份有限公司',
    'participateNum': '10',
    'startTime': '11/03/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.119376'
},
{
    'applyNo': '2023081800016',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.119379',
    'eventName': '台南淨遊趣淨灘',
    'id': 334,
    'location': '安平堤頂自行車道',
    'organizer': '台南淨遊趣',
    'participateNum': '80',
    'startTime': '08/26/2023 16:30:00',
    'updated': '2024-05-14 06:50:55.119383'
},
{
    'applyNo': '2023081700008',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.119386',
    'eventName': '光田110週年 垃圾清零你我作伙來 活動',
    'id': 335,
    'location': '水裡港福順宮集合 (龍井區三港路26號)',
    'organizer': '光田醫療社團法人光田綜合醫院',
    'participateNum': '300',
    'startTime': '09/16/2023 07:00:00',
    'updated': '2024-05-14 06:50:55.119390'
},
{
    'applyNo': '2023082100001',
    'cityName': '雲林縣',
    'created': '2024-05-14 06:50:55.119393',
    'eventName': '「海上同樂會之摸蛤仔兼洗褲」暨淨灘活動',
    'id': 336,
    'location': '台西海口生活館',
    'organizer': '媳婦兒有限公司',
    'participateNum': '50',
    'startTime': '09/16/2023 14:30:00',
    'updated': '2024-05-14 06:50:55.119396'
},
{
    'applyNo': '2023082200004',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.119400',
    'eventName': '讓我淨你淨灘嘉年華',
    'id': 337,
    'location': '烏石港北提周邊',
    'organizer': 'Vast',
    'participateNum': '50',
    'startTime': '08/26/2023 16:00:00',
    'updated': '2024-05-14 06:50:55.119403'
},
{
    'applyNo': '2023082200010',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119406',
    'eventName': '海龜不哭交友淨灘',
    'id': 338,
    'location': '野柳漁港旁的岩岸',
    'organizer': '海龜不哭',
    'participateNum': '100',
    'startTime': '09/30/2023 16:00:00',
    'updated': '2024-05-14 06:50:55.119410'
},
{
    'applyNo': '2023081700002',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119416',
    'eventName': '112年新北市秋季聯合淨灘',
    'id': 339,
    'location': '八里北堤沙灘',
    'organizer': '新北市政府環境保護局',
    'participateNum': '950',
    'startTime': '09/24/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.119419'
},
{
    'applyNo': '2023082900003',
    'cityName': '花蓮縣',
    'created': '2024-05-14 06:50:55.119423',
    'eventName': '「親近、清淨、東海岸」環保音樂會、淨灘、海廢創生工作坊、無塑暨二手市集',
    'id': 340,
    'location': '太平洋公園南濱段',
    'organizer': '花蓮縣環境保護局',
    'participateNum': '95',
    'startTime': '09/10/2023 16:00:00',
    'updated': '2024-05-14 06:50:55.119429'
},
{
    'applyNo': '2023082400001',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.119433',
    'eventName': '秋季淨灘公益活動',
    'id': 341,
    'location': '桃園市大園區竹圍海水浴場',
    'organizer': '桃園龍德宮',
    'participateNum': '50',
    'startTime': '10/01/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.119436'
},
{
    'applyNo': '2023082700001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119439',
    'eventName': '今日儀器淨灘活動',
    'id': 342,
    'location': '嘉寶里福德宮前面海灘',
    'organizer': '今日儀器(股)有限公司',
    'participateNum': '40',
    'startTime': '09/23/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.119443'
},
{
    'applyNo': '2023082100014',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.119446',
    'eventName': '2023 沒塑去旅行－國際淨灘行動@高雄',
    'id': 343,
    'location': '高雄市林園區中芸海灘',
    'organizer': '荒野保護協會高雄分會',
    'participateNum': '120',
    'startTime': '09/16/2023 14:30:00',
    'updated': '2024-05-14 06:50:55.119449'
},
{
    'applyNo': '2023081700009',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.119453',
    'eventName': '光田110週年 垃圾清零你我作伙來',
    'id': 344,
    'location': '龍井區三港路26號',
    'organizer': '光田醫療社團法人光田綜合醫院',
    'participateNum': '300',
    'startTime': '09/16/2023 07:00:00',
    'updated': '2024-05-14 06:50:55.119456'
},
{
    'applyNo': '2023083000003',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119460',
    'eventName': '淡水區屯山小枋淨灘團',
    'id': 345,
    'location': '新北市淡水區1鄰1號之1',
    'organizer': '淨灘團の LINE💦 ',
    'participateNum': '25',
    'startTime': '09/30/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.119463'
},
{
    'applyNo': '2023083000013',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119467',
    'eventName': '海誓山盟一起來淨灘',
    'id': 346,
    'location': '尖沙腳街沙灘',
    'organizer': '掌握成功管理學院',
    'participateNum': '60',
    'startTime': '10/21/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.119470'
},
{
    'applyNo': '2023083100004',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119473',
    'eventName': 'SALT BEACH CLEANUP',
    'id': 347,
    'location': '萬里頂寮海灘',
    'organizer': 'SALT ',
    'participateNum': '100',
    'startTime': '09/09/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.119477'
},
{
    'applyNo': '2023090100005',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.119480',
    'eventName': '淨灘',
    'id': 348,
    'location': '永安漁港',
    'organizer': '私人',
    'participateNum': '60',
    'startTime': '09/09/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.119484'
},
{
    'applyNo': '2023090600002',
    'cityName': '新竹縣',
    'created': '2024-05-14 06:50:55.119487',
    'eventName': '一起淨灘趣',
    'id': 349,
    'location': '新月沙灣',
    'organizer': '國泰人壽竹北J區',
    'participateNum': '15',
    'startTime': '09/16/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.119490'
},
{
    'applyNo': '2023083000017',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.119512',
    'eventName': '【海好有你 淨栗守護海洋】-愛海淨灘活動',
    'id': 350,
    'location': '後龍漁港附近沙灘',
    'organizer': '舜程創意行銷有限公司',
    'participateNum': '50',
    'startTime': '09/16/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.119516'
},
{
    'applyNo': '2023083000004',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.119526',
    'eventName': '親子家庭日：自主淨灘X唱遊祈福X馬場導覽',
    'id': 351,
    'location': '崎頂海水浴場',
    'organizer': '鳥烏小作工作室',
    'participateNum': '80',
    'startTime': '',
    'updated': '2024-05-14 06:50:55.119526'
},
{
    'applyNo': '2023090100008',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.119532',
    'eventName': '「環保派．海岸行」',
    'id': 352,
    'location': '彰化縣芳苑漢寶濕地',
    'organizer': '森崴能源股份有限公司 專案事業開發處／綠光行動',
    'participateNum': '30',
    'startTime': '09/23/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.119536'
},
{
    'applyNo': '2023090700008',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119548',
    'eventName': '2023年9月16-17日_不廢青年2日淨灘_淺水灣~六塊厝淨灘',
    'id': 353,
    'location': '淺水灣，從沙湖路進去的沙崙湖海岸線!',
    'organizer': '不廢青年',
    'participateNum': '50',
    'startTime': '09/17/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.119551'
},
{
    'applyNo': '2023090700007',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119551',
    'eventName': '2023年9月16-17日_不廢青年2日淨灘_淺水灣~六塊厝淨灘',
    'id': 354,
    'location': '淺水灣，從沙湖路進去的沙崙湖海岸線!',
    'organizer': '不廢青年',
    'participateNum': '50',
    'startTime': '09/16/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.119551'
},
{
    'applyNo': '2023090800002',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.119553',
    'eventName': 'CMC ESG活動',
    'id': 355,
    'location': '觀音溪至大堀溪範圍段',
    'organizer': 'CMC數轉室',
    'participateNum': '20',
    'startTime': '10/13/2023 13:30:00',
    'updated': '2024-05-14 06:50:55.119557'
},
{
    'applyNo': '2023091100008',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.119560',
    'eventName': 'Celanese來淨灘',
    'id': 356,
    'location': '基隆外木山龍蝦麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '20',
    'startTime': '09/27/2023 08:30:00',
    'updated': '2024-05-14 06:50:55.119564'
},
{
    'applyNo': '2023091400001',
    'cityName': '屏東縣',
    'created': '2024-05-14 06:50:55.119567',
    'eventName': '東港淨淨 海好有您',
    'id': 357,
    'location': '東港鎮海公園沙灘',
    'organizer': '佛教慈濟慈善事業基金會',
    'participateNum': '500',
    'startTime': '09/16/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.119570'
},
{
    'applyNo': '2023091200007',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.119574',
    'eventName': '僑光科技大學 觀光與餐旅學院 112年善盡社會責任淨灘活動',
    'id': 358,
    'location': '塭寮漁港',
    'organizer': '僑光科技大學 觀光與餐旅學院',
    'participateNum': '80',
    'startTime': '10/03/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.119577'
},
{
    'applyNo': '2023092500005',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.119581',
    'eventName': '日出防曬淨灘',
    'id': 359,
    'location': '基隆外木山龍蝦麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '10',
    'startTime': '09/30/2023 06:00:00',
    'updated': '2024-05-14 06:50:55.119584'
},
{
    'applyNo': '2023091700001',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.119588',
    'eventName': '當我們鉅在一起淨灘趣！',
    'id': 360,
    'location': '白沙屯沙灘',
    'organizer': '安聯人壽鉅鼎通訊處',
    'participateNum': '100',
    'startTime': '10/21/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.119591'
},
{
    'applyNo': '2023091800005',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.119595',
    'eventName': '台客劇場x高捷「走灘獎」',
    'id': 361,
    'location': '高雄旗津',
    'organizer': '台客劇場x高雄捷運公司',
    'participateNum': '100',
    'startTime': '10/14/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.119598'
},
{
    'applyNo': '2023091900005',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.119602',
    'eventName': '樟樹實中來淨灘',
    'id': 362,
    'location': '基隆外木山龍蝦麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '52',
    'startTime': '09/27/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.119628'
},
{
    'applyNo': '2023091800012',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119628',
    'eventName': '守護海洋公益淨灘',
    'id': 363,
    'location': '牛車寮海岸線',
    'organizer': '威剛科技公益社',
    'participateNum': '30',
    'startTime': '10/28/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.119777'
},
{
    'applyNo': '2023092300001',
    'cityName': '臺東縣',
    'created': '2024-05-14 06:50:55.119782',
    'eventName': '台東區長老教會淨灘活動',
    'id': 364,
    'location': '富岡段海岸',
    'organizer': '石山長老教會',
    'participateNum': '30',
    'startTime': '10/08/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.119785'
},
{
    'applyNo': '2023092000007',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.119792',
    'eventName': '2023 RE-THINK x KIRIN 高雄彌陀淨灘',
    'id': 365,
    'location': '阿公店溪出海口南岸',
    'organizer': '社團法人重新思考環境教育協會',
    'participateNum': '300',
    'startTime': '10/21/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.119795'
},
{
    'applyNo': '2023091800004',
    'cityName': '新竹市',
    'created': '2024-05-14 06:50:55.119799',
    'eventName': '安聯人壽 醫事元培 攜手同濟 一起淨灘',
    'id': 366,
    'location': '南寮漁港魚鱗天梯',
    'organizer': '安聯人壽保險股份有限公司',
    'participateNum': '40',
    'startTime': '11/11/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.119802'
},
{
    'applyNo': '2023092700012',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119806',
    'eventName': '海龜不哭交友淨灘',
    'id': 367,
    'location': '萬里海水浴場',
    'organizer': '海龜不哭',
    'participateNum': '100',
    'startTime': '10/29/2023 16:00:00',
    'updated': '2024-05-14 06:50:55.119809'
},
{
    'applyNo': '2023100200019',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.119813',
    'eventName': '打開掌心淨灘',
    'id': 368,
    'location': '基隆外木山龍蝦麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '15',
    'startTime': '10/14/2023 14:30:00',
    'updated': '2024-05-14 06:50:55.119816'
},
{
    'applyNo': '2023100300006',
    'cityName': '花蓮縣',
    'created': '2024-05-14 06:50:55.119820',
    'eventName': '自主淨灘',
    'id': 369,
    'location': '北濱',
    'organizer': '自主',
    'participateNum': '1',
    'startTime': '10/08/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.119823'
},
{
    'applyNo': '2023091200009',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.119829',
    'eventName': '2023淨灘減塑愛地球',
    'id': 370,
    'location': '麗水漁港河堤',
    'organizer': '臺中市文化發展協會',
    'participateNum': '15',
    'startTime': '10/14/2023 08:30:00',
    'updated': '2024-05-14 06:50:55.119832'
},
{
    'applyNo': '2023092100001',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.119836',
    'eventName': '保育生物學課程 大安海灘淨灘',
    'id': 371,
    'location': '大安水蓑衣教育館旁路徑進入海攤',
    'organizer': '東海大學生命科學系',
    'participateNum': '10',
    'startTime': '10/21/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.119839'
},
{
    'applyNo': '2023100400006',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.119843',
    'eventName': '擁抱大海 攜手來淨灘',
    'id': 372,
    'location': '假日之森',
    'organizer': '頭份中區扶輪社',
    'participateNum': '100',
    'startTime': '10/22/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.119846'
},
{
    'applyNo': '2023100700002',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119850',
    'eventName': '守護海洋',
    'id': 373,
    'location': '八里北堤海灘',
    'organizer': '德音國小',
    'participateNum': '90',
    'startTime': '10/14/2023 08:30:00',
    'updated': '2024-05-14 06:50:55.119853'
},
{
    'applyNo': '2023092800005',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.119857',
    'eventName': '與英商英商雪莉帕森一起淨灘趣',
    'id': 374,
    'location': '台中大安南埔海堤',
    'organizer': '英商雪莉帕森專業服務有限公司台灣分公司',
    'participateNum': '9',
    'startTime': '10/21/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.119860'
},
{
    'applyNo': '2023100800003',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.119864',
    'eventName': '11/04  Remove ~『高雄旗津』秋季淨灘行動',
    'id': 375,
    'location': '旗津海水浴場',
    'organizer': 'Remove Waste守護者行動',
    'participateNum': '35',
    'startTime': '11/04/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.119867'
},
{
    'applyNo': '2023100800004',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.119871',
    'eventName': '環保公益淨灘',
    'id': 376,
    'location': '蚵仔寮海灘',
    'organizer': '高雄市光明慈善文教協會',
    'participateNum': '30',
    'startTime': '11/04/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.119874'
},
{
    'applyNo': '2023110900001',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.119877',
    'eventName': '海洋世界-藝起淨灘給動物乾淨的環境',
    'id': 377,
    'location': '沙崙段',
    'organizer': '桃園市私立中正藝文幼兒園',
    'participateNum': '30',
    'startTime': '11/22/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.119881'
},
{
    'applyNo': '2023100600006',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.119887',
    'eventName': '淞洋家庭日-為海洋"淨"一分心力',
    'id': 378,
    'location': '觀音海水浴場',
    'organizer': '淞洋有限公司',
    'participateNum': '40',
    'startTime': '11/26/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.119890'
},
{
    'applyNo': '2023101100013',
    'cityName': '花蓮縣',
    'created': '2024-05-14 06:50:55.119894',
    'eventName': '淨灘',
    'id': 379,
    'location': '北濱',
    'organizer': '自主',
    'participateNum': '2',
    'startTime': '10/15/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.119897'
},
{
    'applyNo': '2023101100021',
    'cityName': '花蓮縣',
    'created': '2024-05-14 06:50:55.119901',
    'eventName': '愛花蓮秋日淨灘活動',
    'id': 380,
    'location': '加灣媽宮開始至三棧溪出海口段',
    'organizer': '火車頭烤肉屋及旅充人文民宿',
    'participateNum': '30',
    'startTime': '11/11/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.119904'
},
{
    'applyNo': '2023101600005',
    'cityName': '臺東縣',
    'created': '2024-05-14 06:50:55.119908',
    'eventName': '藍海之秋 淨灘嘉年華',
    'id': 381,
    'location': '臺東縣環境保護局',
    'organizer': '臺東縣環境保護局',
    'participateNum': '300',
    'startTime': '10/21/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.119911'
},
{
    'applyNo': '2023101500004',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.119915',
    'eventName': '第36場接力行動',
    'id': 382,
    'location': '冬山河清水港尾',
    'organizer': '海邊的接力賽',
    'participateNum': '20',
    'startTime': '10/24/2023 08:30:00',
    'updated': '2024-05-14 06:50:55.119918'
},
{
    'applyNo': '2023092800006',
    'cityName': '臺東縣',
    'created': '2024-05-14 06:50:55.119922',
    'eventName': '台澎淨灘連線：史前館×海漂實驗室',
    'id': 383,
    'location': '金樽陸連島海岸線',
    'organizer': '國立臺灣史前文化博物館',
    'participateNum': '20',
    'startTime': '10/22/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.119925'
},
{
    'applyNo': '2023101500005',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.119928',
    'eventName': '台南淨遊趣淨灘',
    'id': 384,
    'location': '漁光島北邊海灘',
    'organizer': '台南淨遊趣',
    'participateNum': '100',
    'startTime': '10/21/2023 08:30:00',
    'updated': '2024-05-14 06:50:55.119932'
},
{
    'applyNo': '2023101600008',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119935',
    'eventName': '履行義工',
    'id': 385,
    'location': '金山水尾漁港停車場前沙灘',
    'organizer': '海韻電子工業股份有限公司',
    'participateNum': '15',
    'startTime': '10/28/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.119939'
},
{
    'applyNo': '2023101900012',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.119942',
    'eventName': '11/12 Remove 『台南安平』秋季淨灘行動',
    'id': 386,
    'location': '安平觀夕平台',
    'organizer': 'Remove Waste守護者行動',
    'participateNum': '30',
    'startTime': '11/12/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.119946'
},
{
    'applyNo': '2023102300003',
    'cityName': '花蓮縣',
    'created': '2024-05-14 06:50:55.119949',
    'eventName': '自主',
    'id': 387,
    'location': '花蓮',
    'organizer': '自主',
    'participateNum': '1',
    'startTime': '10/24/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.119953'
},
{
    'applyNo': '2023102500003',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119956',
    'eventName': '國泰世華商業銀行八里北堤淨灘活動',
    'id': 388,
    'location': '八里北堤沙灘',
    'organizer': '國泰世華商業銀行',
    'participateNum': '20',
    'startTime': '11/17/2023 13:00:00',
    'updated': '2024-05-14 06:50:55.119962'
},
{
    'applyNo': '2023102700004',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.119966',
    'eventName': '友善海洋 永續生活',
    'id': 389,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '300',
    'startTime': '11/18/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.119969'
},
{
    'applyNo': '2023102700005',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.119973',
    'eventName': '友善海洋 永續生活',
    'id': 390,
    'location': '苗栗縣後龍鎮南港漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '300',
    'startTime': '11/26/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.119976'
},
{
    'applyNo': '2023103100006',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119982',
    'eventName': '海龜不哭交友淨灘',
    'id': 391,
    'location': '野柳漁港旁的岩岸',
    'organizer': '海龜不哭',
    'participateNum': '100',
    'startTime': '11/26/2023 13:00:00',
    'updated': '2024-05-14 06:50:55.119985'
},
{
    'applyNo': '2023110600007',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.119989',
    'eventName': '八里挖子尾海灘淨灘',
    'id': 392,
    'location': '八里挖子尾海灘淨灘',
    'organizer': '台灣遊山玩水協會',
    'participateNum': '10',
    'startTime': '11/11/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.119992'
},
{
    'applyNo': '2023103100008',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.119996',
    'eventName': '搶救海洋大作戰~',
    'id': 393,
    'location': '台中市大安區龜殼生態公園的海岸線',
    'organizer': '林小佐',
    'participateNum': '15',
    'startTime': '11/17/2023 15:30:00',
    'updated': '2024-05-14 06:50:55.119999'
},
{
    'applyNo': '2023110900009',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.120003',
    'eventName': '樂耕淨灘',
    'id': 394,
    'location': '基隆外木山益心居海鮮麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '25',
    'startTime': '11/26/2023 13:30:00',
    'updated': '2024-05-14 06:50:55.120006'
},
{
    'applyNo': '2023110300009',
    'cityName': '新竹市',
    'created': '2024-05-14 06:50:55.120010',
    'eventName': '馬爾地夫計畫-永續海洋資源',
    'id': 395,
    'location': '新竹南寮漁港-魚鱗天梯',
    'organizer': '亞洲科莫丹股份有限公司',
    'participateNum': '40',
    'startTime': '01/06/2024 14:00:00',
    'updated': '2024-05-14 06:50:55.120013'
},
{
    'applyNo': '2023111500005',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120017',
    'eventName': '我愛大自然',
    'id': 396,
    'location': '林口嘉寶沙灘',
    'organizer': '石牌玄帝宮',
    'participateNum': '16',
    'startTime': '12/03/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.120020'
},
{
    'applyNo': '2023111100002',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.120024',
    'eventName': '為美麗的海洋 留下美麗',
    'id': 397,
    'location': '夕陽關照的蝦猴保育區',
    'organizer': '中部淨灘趣',
    'participateNum': '20',
    'startTime': '12/02/2023 15:00:00',
    'updated': '2024-05-14 06:50:55.120027'
},
{
    'applyNo': '2023111300007',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.120031',
    'eventName': '生存淨灘運動',
    'id': 398,
    'location': '市境之南樹',
    'organizer': '生存運動團體',
    'participateNum': '18',
    'startTime': '11/26/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.120034'
},
{
    'applyNo': '2023111300004',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.120038',
    'eventName': '淨灘淨攤',
    'id': 399,
    'location': '淨灘旗津段',
    'organizer': '中國人壽高屏直轄通訊處',
    'participateNum': '25',
    'startTime': '11/26/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.120041'
},
{
    'applyNo': '2023111200002',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.120044',
    'eventName': '環保公益淨灘',
    'id': 400,
    'location': '蚵仔寮海灘',
    'organizer': '高雄市光明慈善文教協會',
    'participateNum': '35',
    'startTime': '12/03/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.120048'
},
{
    'applyNo': '2023111600004',
    'cityName': '臺東縣',
    'created': '2024-05-14 06:50:55.120052',
    'eventName': '2023淨愛台東',
    'id': 401,
    'location': '台東森林公園海濱段',
    'organizer': '富邦人壽東陽通訊處',
    'participateNum': '30',
    'startTime': '11/18/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.120055'
},
{
    'applyNo': '2023112000006',
    'cityName': '花蓮縣',
    'created': '2024-05-14 06:50:55.120059',
    'eventName': '自主',
    'id': 402,
    'location': '北濱入口',
    'organizer': '自主',
    'participateNum': '2',
    'startTime': '11/27/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.120062'
},
{
    'applyNo': '2023112100005',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120066',
    'eventName': '八里挖子尾海灘淨灘',
    'id': 403,
    'location': '八里挖子尾海灘',
    'organizer': '台灣遊山玩水協會',
    'participateNum': '20',
    'startTime': '12/09/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.120069'
},
{
    'applyNo': '2023112000001',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120075',
    'eventName': '沙崙淨灘囉',
    'id': 404,
    'location': '沙崙海灘',
    'organizer': '個人',
    'participateNum': '20',
    'startTime': '12/03/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.120079'
},
{
    'applyNo': '2023112800007',
    'cityName': '屏東縣',
    'created': '2024-05-14 06:50:55.120082',
    'eventName': '「為海而來」淨灘活動',
    'id': 405,
    'location': '屏東縣林邊鄉崎峰海岸線',
    'organizer': '社團法人屏東縣溫馨關懷協會',
    'participateNum': '30',
    'startTime': '12/24/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.120086'
},
{
    'applyNo': '2023113000003',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120089',
    'eventName': '第四次鴻元家庭淨灘公益活動',
    'id': 406,
    'location': '八里挖子尾海灘(觀海長堤左側海灘)',
    'organizer': '無極祖敕鴻元殿',
    'participateNum': '10',
    'startTime': '12/10/2023 08:00:00',
    'updated': '2024-05-14 06:50:55.120092'
},
{
    'applyNo': '2024010200005',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.120096',
    'eventName': '第43場接力行動',
    'id': 407,
    'location': '大溪漁港北側海灘',
    'organizer': '海邊的接力賽',
    'participateNum': '10',
    'startTime': '01/09/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120099'
},
{
    'applyNo': '2023122600002',
    'cityName': '雲林縣',
    'created': '2024-05-14 06:50:55.120103',
    'eventName': '永寬化學，邀您攜手護海洋',
    'id': 408,
    'location': '五條港安檢所 ',
    'organizer': '永寬化學股份有限公司',
    'participateNum': '40',
    'startTime': '03/16/2024 09:30:00',
    'updated': '2024-05-14 06:50:55.120106'
},
{
    'applyNo': '2024041100002',
    'cityName': '雲林縣',
    'created': '2024-05-14 06:50:55.120110',
    'eventName': '猛農海上見面會',
    'id': 409,
    'location': '箔仔寮北堤',
    'organizer': '媳婦兒有限公司',
    'participateNum': '50',
    'startTime': '04/27/2024 14:00:00',
    'updated': '2024-05-14 06:50:55.120113'
},
{
    'applyNo': '2024042900004',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.120117',
    'eventName': '台北市日月光獅子會淨灘社福活動',
    'id': 410,
    'location': '白沙屯海岸及漁港周邊',
    'organizer': '台北市日月光獅子會',
    'participateNum': '40',
    'startTime': '05/25/2024 10:00:00',
    'updated': '2024-05-14 06:50:55.120120'
},
{
    'applyNo': '2023113000007',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.120124',
    'eventName': '崎頂淨灘活動',
    'id': 411,
    'location': '配合海水浴場內(配合開幕典禮邀請現場遊客朋友共同為海洋盡一份心力)',
    'organizer': '崎頂新樂園',
    'participateNum': '30',
    'startTime': '12/16/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.120127'
},
{
    'applyNo': '2023113000011',
    'cityName': '新竹縣',
    'created': '2024-05-14 06:50:55.120130',
    'eventName': '竹中105淨灘第二團',
    'id': 412,
    'location': '新月沙灣-1',
    'organizer': '學生',
    'participateNum': '7',
    'startTime': '12/17/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.120134'
},
{
    'applyNo': '2023112300001',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.120137',
    'eventName': '12/23 Remove 『高雄蚵仔寮』冬季聖誕淨灘行動',
    'id': 413,
    'location': '梓官-蚵仔寮沙灘',
    'organizer': 'Remove Waste守護者行動',
    'participateNum': '50',
    'startTime': '12/23/2023 14:00:00',
    'updated': '2024-05-14 06:50:55.120143'
},
{
    'applyNo': '2023120400004',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120147',
    'eventName': '共同守護保安林-編號第1003號保安林淨灘暨命名活動',
    'id': 414,
    'location': '新北市萬里區下寮海灘',
    'organizer': '林業保育署宜蘭分署',
    'participateNum': '300',
    'startTime': '12/08/2023 09:30:00',
    'updated': '2024-05-14 06:50:55.120150'
},
{
    'applyNo': '2023120100003',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.120154',
    'eventName': '第40場公開行動',
    'id': 415,
    'location': '頭城梗枋福神碑',
    'organizer': '海邊的接力賽',
    'participateNum': '10',
    'startTime': '12/12/2023 09:00:00',
    'updated': '2024-05-14 06:50:55.120157'
},
{
    'applyNo': '2023120400006',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120161',
    'eventName': '懿鑫商學院-淨灘行動',
    'id': 416,
    'location': '淡水沙崙海灘 ',
    'organizer': '懿鑫國際股份有限公司',
    'participateNum': '30',
    'startTime': '01/20/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120164'
},
{
    'applyNo': '2023120800002',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120170',
    'eventName': '擁抱海洋X探索古早人情味',
    'id': 417,
    'location': '萬里萬里海灘(瑪鋉溪旁沙灘)',
    'organizer': '華梵大學',
    'participateNum': '25',
    'startTime': '12/16/2023 10:00:00',
    'updated': '2024-05-14 06:50:55.120173'
},
{
    'applyNo': '2023120400007',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.120177',
    'eventName': '為美麗的海洋 留下美麗',
    'id': 418,
    'location': '夕陽關照的蝦猴保育區',
    'organizer': '中部淨灘趣',
    'participateNum': '20',
    'startTime': '01/06/2024 15:00:00',
    'updated': '2024-05-14 06:50:55.120180'
},
{
    'applyNo': '2024011000007',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.120184',
    'eventName': '愛護海洋攜手合作',
    'id': 419,
    'location': '彌陀海岸光廊',
    'organizer': '雄讚海岸巡守志工隊',
    'participateNum': '15',
    'startTime': '01/27/2024 15:00:00',
    'updated': '2024-05-14 06:50:55.120187'
},
{
    'applyNo': '2024031400013',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120191',
    'eventName': '改善海岸風景',
    'id': 420,
    'location': '淡水沙崙海灘',
    'organizer': '康寧大學護理科二年仁班',
    'participateNum': '47',
    'startTime': '05/01/2024 13:00:00',
    'updated': '2024-05-14 06:50:55.120194'
},
{
    'applyNo': '2023120800001',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.120197',
    'eventName': '01/06 Remove ~『台南安平』冬季迎新淨灘行動',
    'id': 421,
    'location': '台南-安平觀夕平台',
    'organizer': 'Remove Waste守護者行動',
    'participateNum': '50',
    'startTime': '01/06/2024 09:30:00',
    'updated': '2024-05-14 06:50:55.120201'
},
{
    'applyNo': '2023121300002',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120204',
    'eventName': '風浪板愛海灘',
    'id': 422,
    'location': '下福沙灘',
    'organizer': '下福風浪板俱樂部',
    'participateNum': '20',
    'startTime': '12/16/2023 06:00:00',
    'updated': '2024-05-14 06:50:55.120208'
},
{
    'applyNo': '2023121800001',
    'cityName': '新竹縣',
    'created': '2024-05-14 06:50:55.120211',
    'eventName': '年前淨灘，放假安心玩耍',
    'id': 423,
    'location': '馬祖廟',
    'organizer': '地球的孩子',
    'participateNum': '25',
    'startTime': '01/28/2024 10:30:00',
    'updated': '2024-05-14 06:50:55.120215'
},
{
    'applyNo': '2023122500003',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.120218',
    'eventName': '獻海風淨灘',
    'id': 424,
    'location': '基隆外木山海鮮麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '5',
    'startTime': '01/07/2024 09:30:00',
    'updated': '2024-05-14 06:50:55.120221'
},
{
    'applyNo': '2024010200003',
    'cityName': '新竹縣',
    'created': '2024-05-14 06:50:55.120225',
    'eventName': '守護海洋，攜手淨灘',
    'id': 425,
    'location': '舊新豐海水浴場',
    'organizer': '亞洲科莫丹股份有限公司',
    'participateNum': '50',
    'startTime': '03/10/2024 14:00:00',
    'updated': '2024-05-14 06:50:55.120228'
},
{
    'applyNo': '2024010500002',
    'cityName': '嘉義縣',
    'created': '2024-05-14 06:50:55.120232',
    'eventName': '2024和泰集團淨灘減塑全台總動員',
    'id': 426,
    'location': '嘉義好美里海岸',
    'organizer': '南都汽車股份有限公司',
    'participateNum': '100',
    'startTime': '04/21/2024 08:00:00',
    'updated': '2024-05-14 06:50:55.120235'
},
{
    'applyNo': '2024010700002',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.120239',
    'eventName': '台南淨遊趣淨灘',
    'id': 427,
    'location': '橋頭海灘公園',
    'organizer': '台南淨遊趣',
    'participateNum': '50',
    'startTime': '01/14/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120242'
},
{
    'applyNo': '2024011000008',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.120245',
    'eventName': '海樂森-熊熊想上陸',
    'id': 428,
    'location': '大武崙澳底沙灘',
    'organizer': '海樂森',
    'participateNum': '100',
    'startTime': '02/17/2024 09:30:00',
    'updated': '2024-05-14 06:50:55.120249'
},
{
    'applyNo': '2024010700003',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120252',
    'eventName': '邱義洋薛紹芸婚禮淨灘',
    'id': 429,
    'location': '藍色公路海景咖啡館下方沙灘，林口大坑站前海岸',
    'organizer': '邱義洋薛紹芸婚禮淨灘團',
    'participateNum': '75',
    'startTime': '01/20/2024 16:00:00',
    'updated': '2024-05-14 06:50:55.120256'
},
{
    'applyNo': '2024010500003',
    'cityName': '雲林縣',
    'created': '2024-05-14 06:50:55.120262',
    'eventName': '2024和泰集團淨灘減塑全台總動員',
    'id': 430,
    'location': '雲林許厝寮漁港',
    'organizer': '南都汽車股份有限公司',
    'participateNum': '100',
    'startTime': '04/21/2024 08:00:00',
    'updated': '2024-05-14 06:50:55.120265'
},
{
    'applyNo': '2024032600005',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120269',
    'eventName': '昇恆昌淺水灣淨灘活動',
    'id': 431,
    'location': '三芝淺水灣段二',
    'organizer': '昇恆昌股份有限公司',
    'participateNum': '40',
    'startTime': '04/20/2024 13:00:00',
    'updated': '2024-05-14 06:50:55.120272'
},
{
    'applyNo': '2024011500004',
    'cityName': '新竹縣',
    'created': '2024-05-14 06:50:55.120276',
    'eventName': '淨灘愛台灣~『海』好有青年暨環保宣導活動',
    'id': 432,
    'location': '新月沙灣海岸線',
    'organizer': '中國青年救國團直屬臺灣省新竹團務指導委員會',
    'participateNum': '40',
    'startTime': '03/02/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120279'
},
{
    'applyNo': '2024010900005',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120285',
    'eventName': '我們要淨灘！',
    'id': 433,
    'location': '新北八里挖子尾海灘',
    'organizer': 'The\u2002first\u2002step\u2002is\u2002always\u2002the\u2002hardest',
    'participateNum': '25',
    'startTime': '01/21/2024 15:00:00',
    'updated': '2024-05-14 06:50:55.120288'
},
{
    'applyNo': '2024012000002',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.120292',
    'eventName': '白沙屯海灘守護者:沙灘淨化行動',
    'id': 434,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '300',
    'startTime': '02/18/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120295'
},
{
    'applyNo': '2024011900005',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.120299',
    'eventName': '第44場接力行動',
    'id': 435,
    'location': '頭城竹安出海口南側',
    'organizer': '海邊的接力賽',
    'participateNum': '40',
    'startTime': '01/27/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120302'
},
{
    'applyNo': '2024012200002',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120306',
    'eventName': '石門淨灘',
    'id': 436,
    'location': '石門海灘',
    'organizer': '淨灘團體',
    'participateNum': '16',
    'startTime': '01/28/2024 10:00:00',
    'updated': '2024-05-14 06:50:55.120309'
},
{
    'applyNo': '2024011900001',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.120313',
    'eventName': '為美麗的海洋 留下美麗',
    'id': 437,
    'location': '夕陽關照的蝦猴保育區',
    'organizer': '中部淨灘趣',
    'participateNum': '20',
    'startTime': '02/17/2024 15:00:00',
    'updated': '2024-05-14 06:50:55.120316'
},
{
    'applyNo': '2024021600006',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.120320',
    'eventName': '第45場接力行動',
    'id': 438,
    'location': '蘇澳澳仔角',
    'organizer': '海邊的接力賽',
    'participateNum': '10',
    'startTime': '02/20/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120327'
},
{
    'applyNo': '2024021600003',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120330',
    'eventName': '八里北堤海灘',
    'id': 439,
    'location': '八里-北堤沙灘(八里區挖子尾街1號)',
    'organizer': '昇恆昌股份有限公司(內湖旗艦店)',
    'participateNum': '80',
    'startTime': '03/16/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120334'
},
{
    'applyNo': '2024012800001',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.120337',
    'eventName': 'BE79春玩影專淨灘活動',
    'id': 440,
    'location': '苗栗通宵白沙屯漁港',
    'organizer': 'BE79',
    'participateNum': '40',
    'startTime': '03/16/2024 11:00:00',
    'updated': '2024-05-14 06:50:55.120341'
},
{
    'applyNo': '2024012600005',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120344',
    'eventName': '護眾生愛地球',
    'id': 441,
    'location': '林口藍色公路海景咖啡館前海岸',
    'organizer': '淨心淨灘團',
    'participateNum': '20',
    'startTime': '02/21/2024 08:30:00',
    'updated': '2024-05-14 06:50:55.120348'
},
{
    'applyNo': '2024020500006',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120351',
    'eventName': '2024 RE-THINK 緣滅淨灘限定場',
    'id': 442,
    'location': '超過百人的舊物交換大會 ☆ 你的廢物說不定是我的寶貝 ☆',
    'organizer': '社團法人台灣重新思考環境教育協會',
    'participateNum': '300',
    'startTime': '03/02/2024 15:00:00',
    'updated': '2024-05-14 06:50:55.120355'
},
{
    'applyNo': '2024020600007',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.120361',
    'eventName': '龍蹤來',
    'id': 443,
    'location': '基隆外木山益心居海鮮麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '15',
    'startTime': '02/18/2024 14:00:00',
    'updated': '2024-05-14 06:50:55.120364'
},
{
    'applyNo': '2024020200006',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.120368',
    'eventName': '珍愛鑽石，守護沙灣',
    'id': 444,
    'location': '永安鑽石沙灣',
    'organizer': '雄讚海岸巡守志工隊',
    'participateNum': '15',
    'startTime': '02/25/2024 15:00:00',
    'updated': '2024-05-14 06:50:55.120371'
},
{
    'applyNo': '2024021900004',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.120375',
    'eventName': '淨灘愛地球',
    'id': 445,
    'location': '龍鳳漁港',
    'organizer': '一般民眾',
    'participateNum': '1',
    'startTime': '02/22/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120378'
},
{
    'applyNo': '2024022900010',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.120382',
    'eventName': '喜悅淨灘',
    'id': 446,
    'location': '基隆外木山益心居海鮮麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '30',
    'startTime': '03/31/2024 14:00:00',
    'updated': '2024-05-14 06:50:55.120385'
},
{
    'applyNo': '2024012300005',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.120389',
    'eventName': '02/24 Remove ~『高雄旗津』春季淨灘行動',
    'id': 447,
    'location': '旗津',
    'organizer': 'Remove Waste守護者行動(沐福環境暨社會關懷)',
    'participateNum': '40',
    'startTime': '02/24/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120392'
},
{
    'applyNo': '2024021900011',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.120396',
    'eventName': '白沙屯海灘守護者:沙灘淨化行動',
    'id': 448,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '200',
    'startTime': '03/09/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120399'
},
{
    'applyNo': '2024021900014',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.120403',
    'eventName': '觀夕平台淨灘',
    'id': 449,
    'location': '觀夕平台',
    'organizer': '成大南工',
    'participateNum': '80',
    'startTime': '03/20/2024 13:30:00',
    'updated': '2024-05-14 06:50:55.120406'
},
{
    'applyNo': '2024022200010',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120410',
    'eventName': '淨灘暨愛心關懷公益自強活動',
    'id': 450,
    'location': '萬里翡翠灣',
    'organizer': '元寶道院',
    'participateNum': '40',
    'startTime': '03/30/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120413'
},
{
    'applyNo': '2024022300012',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120416',
    'eventName': '守護海洋之心-海岸清除師淨走計畫',
    'id': 451,
    'location': '八里北堤沙灘(污水處理廠後方海灘) 「入口處」',
    'organizer': '德明財經科技大學',
    'participateNum': '80',
    'startTime': '03/30/2024 08:30:00',
    'updated': '2024-05-14 06:50:55.120420'
},
{
    'applyNo': '2024022600002',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.120423',
    'eventName': '拯救地球',
    'id': 452,
    'location': '龍鳳漁港',
    'organizer': '一般民眾',
    'participateNum': '1',
    'startTime': '02/29/2024 08:00:00',
    'updated': '2024-05-14 06:50:55.120427'
},
{
    'applyNo': '2024022900014',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.120430',
    'eventName': '台南淨遊趣淨灘',
    'id': 453,
    'location': '安平堤頂自行車道',
    'organizer': '台南淨遊趣',
    'participateNum': '80',
    'startTime': '03/09/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120434'
},
{
    'applyNo': '2024022800003',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120437',
    'eventName': '第五次鴻元家庭淨灘公益活動',
    'id': 454,
    'location': '八里長堤海灘',
    'organizer': '無極祖敕鴻元殿',
    'participateNum': '10',
    'startTime': '03/10/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120440'
},
{
    'applyNo': '2024022400002',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.120444',
    'eventName': '環保公益淨灘',
    'id': 455,
    'location': '蚵仔寮海灘',
    'organizer': '高雄市光明慈善文教協會',
    'participateNum': '30',
    'startTime': '03/09/2024 08:00:00',
    'updated': '2024-05-14 06:50:55.120447'
},
{
    'applyNo': '2024030400013',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120453',
    'eventName': '海龜不哭交友淨灘',
    'id': 456,
    'location': '野柳漁港旁的岩岸',
    'organizer': '海龜不哭',
    'participateNum': '100',
    'startTime': '03/31/2024 13:00:00',
    'updated': '2024-05-14 06:50:55.120457'
},
{
    'applyNo': '2024022800006',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.120460',
    'eventName': '2024 RE-THINK 淨灘桃園場',
    'id': 457,
    'location': '桃園後厝港',
    'organizer': '社團法人台灣重新思考環境教育協會',
    'participateNum': '250',
    'startTime': '03/23/2024 15:00:00',
    'updated': '2024-05-14 06:50:55.120464'
},
{
    'applyNo': '2024030500016',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.120467',
    'eventName': '一起來淨灘',
    'id': 458,
    'location': '觀音海水浴場',
    'organizer': '凱基證券',
    'participateNum': '20',
    'startTime': '03/24/2024 09:30:00',
    'updated': '2024-05-14 06:50:55.120471'
},
{
    'applyNo': '2024030700002',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.120474',
    'eventName': '淨灘',
    'id': 459,
    'location': '富林溪至樹林後溪',
    'organizer': '台灣永光化學工業(股)公司第三廠',
    'participateNum': '50',
    'startTime': '05/25/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120478'
},
{
    'applyNo': '2024030700007',
    'cityName': '屏東縣',
    'created': '2024-05-14 06:50:55.120481',
    'eventName': 'MAHIMAHI海好友你',
    'id': 460,
    'location': '鹽埔共和進海宮附近海域',
    'organizer': '鷗軒水事興業有限公司',
    'participateNum': '20',
    'startTime': '04/14/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120485'
},
{
    'applyNo': '2024030500018',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120488',
    'eventName': '讓愛走動',
    'id': 461,
    'location': '沙崙海灘',
    'organizer': '台北市基督教浸信會懷恩堂',
    'participateNum': '40',
    'startTime': '06/01/2024 10:00:00',
    'updated': '2024-05-14 06:50:55.120492'
},
{
    'applyNo': '2024030900001',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.120495',
    'eventName': '白沙屯淨灘',
    'id': 462,
    'location': '白沙屯拱天宮後方海岸線',
    'organizer': '社團法人耕善學佛會',
    'participateNum': '20',
    'startTime': '03/23/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120499'
},
{
    'applyNo': '2024030100012',
    'cityName': '雲林縣',
    'created': '2024-05-14 06:50:55.120502',
    'eventName': '不髒我不撿首發場！雲林四湖淨灘活動',
    'id': 463,
    'location': '箔子寮漁港垂釣區旁https://maps.app.goo.gl/BWfjoT8HiVGppHpJ7',
    'organizer': '不髒我不撿',
    'participateNum': '50',
    'startTime': '04/04/2024 15:00:00',
    'updated': '2024-05-14 06:50:55.120513'
},
{
    'applyNo': '2024030900003',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120517',
    'eventName': '靈源寺宮慶公益活動',
    'id': 464,
    'location': '萬里下寮海灘',
    'organizer': '惠心關懷協會',
    'participateNum': '50',
    'startTime': '04/21/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120521'
},
{
    'applyNo': '2024031800002',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.120524',
    'eventName': '淞洋家庭日-為海洋"淨"一分心力',
    'id': 465,
    'location': '觀音海水浴場',
    'organizer': '淞洋有限公司',
    'participateNum': '60',
    'startTime': '04/21/2024 09:30:00',
    'updated': '2024-05-14 06:50:55.120528'
},
{
    'applyNo': '2024031100019',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.120531',
    'eventName': '白沙屯海灘守護者:沙灘淨化行動',
    'id': 466,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '250',
    'startTime': '04/14/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120535'
},
{
    'applyNo': '2024031100021',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.120538',
    'eventName': '草漯清淨沙丘',
    'id': 467,
    'location': '草漯沙丘地質公園-觀音白沙屯觀景步道',
    'organizer': '禾大國際管理顧問股份有限公司',
    'participateNum': '40',
    'startTime': '04/13/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120542'
},
{
    'applyNo': '2024031800001',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.120545',
    'eventName': '第49場接力行動',
    'id': 468,
    'location': '蘇澳大坑罟 ',
    'organizer': '海邊的接力賽',
    'participateNum': '80',
    'startTime': '03/24/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120549'
},
{
    'applyNo': '2024031800013',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120555',
    'eventName': '就是要淨灘',
    'id': 469,
    'location': '象鼻岩',
    'organizer': '就是要淨灘',
    'participateNum': '10',
    'startTime': '03/31/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120558'
},
{
    'applyNo': '2024032500013',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.120562',
    'eventName': '愛台灣愛大海',
    'id': 470,
    'location': '內海許厝港段',
    'organizer': '台灣民眾黨桃園市黨部',
    'participateNum': '150',
    'startTime': '05/18/2024 12:00:00',
    'updated': '2024-05-14 06:50:55.120565'
},
{
    'applyNo': '2024031200011',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.120569',
    'eventName': '設教70週年慶～我愛大園',
    'id': 471,
    'location': '許厝港溼地海岸',
    'organizer': '台灣基督長老教會大園教會',
    'participateNum': '100',
    'startTime': '04/28/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120572'
},
{
    'applyNo': '2024031800022',
    'cityName': '新竹市',
    'created': '2024-05-14 06:50:55.120576',
    'eventName': '大竹光愛地球淨灘日，一起做公益你我都受益',
    'id': 472,
    'location': '惠民宮',
    'organizer': '富邦人壽（大竹光團隊）',
    'participateNum': '100',
    'startTime': '04/13/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120579'
},
{
    'applyNo': '2024031800016',
    'cityName': '新竹市',
    'created': '2024-05-14 06:50:55.120583',
    'eventName': '2403愛沙灘淨灘活動',
    'id': 473,
    'location': '幸福沙灣',
    'organizer': '亞洲科莫丹股份有限公司',
    'participateNum': '50',
    'startTime': '05/05/2024 14:00:00',
    'updated': '2024-05-14 06:50:55.120586'
},
{
    'applyNo': '2024032800006',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.120590',
    'eventName': '關懷大地、潔淨地球淨灘環境教育暨社會福利宣導活動',
    'id': 474,
    'location': '南崁港以北海岸線',
    'organizer': '桃園市蘆竹區濱海社區發展協會',
    'participateNum': '270',
    'startTime': '04/21/2024 07:30:00',
    'updated': '2024-05-14 06:50:55.120593'
},
{
    'applyNo': '2024032600021',
    'cityName': '新竹市',
    'created': '2024-05-14 06:50:55.120596',
    'eventName': '親親海灘愛的淨化時刻',
    'id': 475,
    'location': '南竂漁港觀音亭北岸',
    'organizer': '聚集德非營利幼兒園',
    'participateNum': '500',
    'startTime': '04/20/2024 07:30:00',
    'updated': '2024-05-14 06:50:55.120600'
},
{
    'applyNo': '2024040300004',
    'cityName': '新竹市',
    'created': '2024-05-14 06:50:55.120606',
    'eventName': '新竹go愛地球淨灘-第8場',
    'id': 476,
    'location': '新竹市香山區金城湖',
    'organizer': '新竹go愛地球淨灘',
    'participateNum': '50',
    'startTime': '04/27/2024 08:00:00',
    'updated': '2024-05-14 06:50:55.120609'
},
{
    'applyNo': '2024032800008',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.120613',
    'eventName': '4/27  Remove ~『高雄蚵仔寮』淨灘行動',
    'id': 477,
    'location': '梓官-蚵仔寮沙灘',
    'organizer': 'Remove Waste守護者行動(沐福環境暨社會關懷海岸巡守志工隊)',
    'participateNum': '40',
    'startTime': '04/27/2024 14:00:00',
    'updated': '2024-05-14 06:50:55.120616'
},
{
    'applyNo': '2024032600024',
    'cityName': '高雄市',
    'created': '2024-05-14 06:50:55.120620',
    'eventName': '顏值擔當之戶外好動社淨灘活動',
    'id': 478,
    'location': '旗津海水浴場',
    'organizer': '富岳營造股份有限公司',
    'participateNum': '10',
    'startTime': '04/27/2024 08:30:00',
    'updated': '2024-05-14 06:50:55.120623'
},
{
    'applyNo': '2024040300013',
    'cityName': '屏東縣',
    'created': '2024-05-14 06:50:55.120627',
    'eventName': '跟尊青一起讓地球更好',
    'id': 479,
    'location': '鎮海宮海岸灘',
    'organizer': '尊青行銷股份有限公司',
    'participateNum': '200',
    'startTime': '04/14/2024 15:00:00',
    'updated': '2024-05-14 06:50:55.120630'
},
{
    'applyNo': '2024040300010',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120634',
    'eventName': '海龜不哭交友淨灘',
    'id': 480,
    'location': '萬里海水浴場',
    'organizer': '海龜不哭',
    'participateNum': '100',
    'startTime': '04/28/2024 14:00:00',
    'updated': '2024-05-14 06:50:55.120637'
},
{
    'applyNo': '2024040900004',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120641',
    'eventName': '北海岸淨灘',
    'id': 481,
    'location': '核二廠對面停車場',
    'organizer': '動手愛台灣',
    'participateNum': '150',
    'startTime': '04/21/2024 10:00:00',
    'updated': '2024-05-14 06:50:55.120644'
},
{
    'applyNo': '2024030600010',
    'cityName': '臺中市',
    'created': '2024-05-14 06:50:55.120650',
    'eventName': '2024當我們鉅在一起！',
    'id': 482,
    'location': '台中市大安區溫寮漁港',
    'organizer': '安聯人壽鉅鼎通訊處',
    'participateNum': '30',
    'startTime': '05/01/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120653'
},
{
    'applyNo': '2024040900008',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.120657',
    'eventName': '熊熊想上陸',
    'id': 483,
    'location': '桃園新屋溪出海口',
    'organizer': '社團法人國際戶外教育學會',
    'participateNum': '100',
    'startTime': '05/10/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120660'
},
{
    'applyNo': '2024041000003',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120664',
    'eventName': '淨灘',
    'id': 484,
    'location': '南雅奇岩',
    'organizer': '百岳登山攝',
    'participateNum': '17',
    'startTime': '04/27/2024 08:00:00',
    'updated': '2024-05-14 06:50:55.120667'
},
{
    'applyNo': '2024040300014',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.120671',
    'eventName': '海角樂園淨灘愛台灣',
    'id': 485,
    'location': '苗栗縣後龍鎮海角樂園',
    'organizer': '列日大學16屆EMBA',
    'participateNum': '15',
    'startTime': '05/18/2024 09:30:00',
    'updated': '2024-05-14 06:50:55.120674'
},
{
    'applyNo': '2024041000005',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.120677',
    'eventName': '草漯沙丘x國際家庭日',
    'id': 486,
    'location': '草漯沙丘地質公園-觀音白沙屯觀景步道',
    'organizer': '禾大國際管理顧問股份有限公司',
    'participateNum': '40',
    'startTime': '05/25/2024 14:30:00',
    'updated': '2024-05-14 06:50:55.120681'
},
{
    'applyNo': '2024041400001',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.120684',
    'eventName': '母親節淨灘',
    'id': 487,
    'location': '白沙屯漁港停車場',
    'organizer': '救國團台中市大雅區團部',
    'participateNum': '30',
    'startTime': '05/05/2024 10:00:00',
    'updated': '2024-05-14 06:50:55.120688'
},
{
    'applyNo': '2024041200001',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.120691',
    'eventName': '第53場接力行動',
    'id': 488,
    'location': '蘇澳澳仔角',
    'organizer': '海邊的接力賽',
    'participateNum': '10',
    'startTime': '04/16/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120701'
},
{
    'applyNo': '2024041500014',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.120705',
    'eventName': '白沙屯海灘守護者:沙灘淨化行動',
    'id': 489,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '200',
    'startTime': '05/04/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120709'
},
{
    'applyNo': '2024041700007',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.120712',
    'eventName': '世界地球日',
    'id': 490,
    'location': '彰化縣王功漁港',
    'organizer': '彰化縣王功蚵藝文化協會',
    'participateNum': '300',
    'startTime': '06/14/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120716'
},
{
    'applyNo': '2024041700008',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120719',
    'eventName': '凱基愛地球',
    'id': 491,
    'location': '洲子灣',
    'organizer': '凱基證券（大直總公司）',
    'participateNum': '60',
    'startTime': '05/25/2024 07:30:00',
    'updated': '2024-05-14 06:50:55.120723'
},
{
    'applyNo': '2024041900005',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.120726',
    'eventName': '2024草漯沙丘海洋生態淨灘暨節能減碳愛地球宣導活動',
    'id': 492,
    'location': '草漯沙丘',
    'organizer': '桃園市環境教育文創協會',
    'participateNum': '1000',
    'startTime': '05/05/2024 12:00:00',
    'updated': '2024-05-14 06:50:55.120729'
},
{
    'applyNo': '2024041500013',
    'cityName': '新竹縣',
    'created': '2024-05-14 06:50:55.120733',
    'eventName': 'BBLENS 環保愛地球淨灘活動',
    'id': 493,
    'location': '新豐鄉紅樹林1',
    'organizer': 'BBLENS 宮源國際有限公司',
    'participateNum': '6',
    'startTime': '04/27/2024 14:00:00',
    'updated': '2024-05-14 06:50:55.120736'
},
{
    'applyNo': '2024041700004',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.120740',
    'eventName': '113年度淨林活動',
    'id': 494,
    'location': '笨港社區海岸線保安林',
    'organizer': '桃園市新屋區笨港社區發展協會',
    'participateNum': '50',
    'startTime': '05/12/2024 07:00:00',
    'updated': '2024-05-14 06:50:55.120743'
},
{
    'applyNo': '2024041600009',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.120749',
    'eventName': '海洋教育岸上起',
    'id': 495,
    'location': '🌿台南黃金海岸',
    'organizer': '台南市立復興國中',
    'participateNum': '20',
    'startTime': '06/09/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120753'
},
{
    'applyNo': '2024041900008',
    'cityName': '臺東縣',
    'created': '2024-05-14 06:50:55.120759',
    'eventName': '港好運~文化走讀淨灘活動',
    'id': 496,
    'location': '富岡漁港 登船處 停車場旁',
    'organizer': '臺東縣環境保護局',
    'participateNum': '100',
    'startTime': '04/27/2024 08:00:00',
    'updated': '2024-05-14 06:50:55.120762'
},
{
    'applyNo': '2024042200002',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.120766',
    'eventName': '我是地球環境守護員 彰化淨灘活動',
    'id': 497,
    'location': '伸港鄉蚵寮海岸',
    'organizer': '社團法人彰化愛鄰協會',
    'participateNum': '20',
    'startTime': '06/22/2024 08:30:00',
    'updated': '2024-05-14 06:50:55.120769'
},
{
    'applyNo': '2024042400005',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.120773',
    'eventName': '感恩大地之母淨灘',
    'id': 498,
    'location': '基隆外木山益心居海鮮麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '10',
    'startTime': '05/11/2024 14:00:00',
    'updated': '2024-05-14 06:50:55.120776'
},
{
    'applyNo': '2024042200001',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.120780',
    'eventName': '第57場公開行動',
    'id': 499,
    'location': '蘭陽溪口水鳥保護區',
    'organizer': '海邊的接力賽',
    'participateNum': '200',
    'startTime': '04/28/2024 15:00:00',
    'updated': '2024-05-14 06:50:55.120783'
},
{
    'applyNo': '2024042300012',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.120786',
    'eventName': '淨灘活動',
    'id': 500,
    'location': '伸港白海豚屋',
    'organizer': '彰化縣海上救生協會',
    'participateNum': '100',
    'startTime': '10/13/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120790'
},
{
    'applyNo': '2024042300011',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.120793',
    'eventName': '淨灘活動',
    'id': 501,
    'location': '伸港白海豚屋',
    'organizer': '彰化縣海上救生協會',
    'participateNum': '100',
    'startTime': '08/25/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120797'
},
{
    'applyNo': '2024042300010',
    'cityName': '彰化縣',
    'created': '2024-05-14 06:50:55.120800',
    'eventName': '淨灘活動',
    'id': 502,
    'location': '伸港白海豚屋',
    'organizer': '彰化縣海上救生協會',
    'participateNum': '1000',
    'startTime': '07/14/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120804'
},
{
    'applyNo': '2024050100004',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.120809',
    'eventName': '走出戶外環保愛地球',
    'id': 503,
    'location': '海角樂園',
    'organizer': '台中市大同國際傑人會',
    'participateNum': '30',
    'startTime': '05/19/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120813'
},
{
    'applyNo': '2024043000006',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120816',
    'eventName': '六塊厝漁港潮間帶、沙灘淨灘',
    'id': 504,
    'location': '六塊厝漁港潮間帶、沙灘',
    'organizer': '淨灘LINE',
    'participateNum': '50',
    'startTime': '05/25/2024 14:00:00',
    'updated': '2024-05-14 06:50:55.120819'
},
{
    'applyNo': '2024050200005',
    'cityName': '臺南市',
    'created': '2024-05-14 06:50:55.120823',
    'eventName': '環境關懷-「踏浪而來」親子淨灘活動',
    'id': 505,
    'location': '黃金海岸',
    'organizer': '國立臺南大學小太陽永續社會服務社',
    'participateNum': '50',
    'startTime': '05/11/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120826'
},
{
    'applyNo': '2024050600017',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120830',
    'eventName': '臺北城市科技大學社會責任：四語一真沙崙淨灘活動',
    'id': 506,
    'location': '沙崙沙灘區域',
    'organizer': '臺北城市科技大學應用外語系',
    'participateNum': '32',
    'startTime': '05/23/2024 13:00:00',
    'updated': '2024-05-14 06:50:55.120833'
},
{
    'applyNo': '2024050700004',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120837',
    'eventName': '六月淨灘Go!',
    'id': 507,
    'location': '下寮加投沙灘',
    'organizer': '熱血北海岸淨灘團',
    'participateNum': '50',
    'startTime': '06/15/2024 08:00:00',
    'updated': '2024-05-14 06:50:55.120840'
},
{
    'applyNo': '2024050800008',
    'cityName': '新竹市',
    'created': '2024-05-14 06:50:55.120846',
    'eventName': ' ST Hsinchu Sustainability  Team ',
    'id': 508,
    'location': '南寮漁港觀音亭北岸',
    'organizer': '香港商意法半導體股份有限公司台灣分公司',
    'participateNum': '50',
    'startTime': '05/25/2024 15:00:00',
    'updated': '2024-05-14 06:50:55.120850'
},
{
    'applyNo': '2024050800007',
    'cityName': '宜蘭縣',
    'created': '2024-05-14 06:50:55.120853',
    'eventName': '第59場公開行動',
    'id': 509,
    'location': '蘇澳澳仔角',
    'organizer': '海邊的接力賽',
    'participateNum': '10',
    'startTime': '05/14/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120857'
},
{
    'applyNo': '2024050800016',
    'cityName': '桃園市',
    'created': '2024-05-14 06:50:55.120860',
    'eventName': '草漯沙丘x世界環境日',
    'id': 510,
    'location': '草漯沙丘地質公園-大園潮音海觀景步道',
    'organizer': '禾大國際管理顧問股份有限公司',
    'participateNum': '40',
    'startTime': '06/22/2024 14:30:00',
    'updated': '2024-05-14 06:50:55.120864'
},
{
    'applyNo': '2024051300002',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.120867',
    'eventName': '【海好有你淨栗守護海洋】國際淨灘日。守護海洋和平',
    'id': 511,
    'location': '竹南鎮 假日之森',
    'organizer': '舜程創意行銷有限公司',
    'participateNum': '40',
    'startTime': '09/21/2024 08:30:00',
    'updated': '2024-05-14 06:50:55.120870'
},
{
    'applyNo': '2024051300016',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.120874',
    'eventName': '炙熱的愛淨灘',
    'id': 512,
    'location': '基隆外木山益心居海鮮麻糬前海灘',
    'organizer': '永續海洋外木山工作室',
    'participateNum': '20',
    'startTime': '06/15/2024 14:30:00',
    'updated': '2024-05-14 06:50:55.120877'
},
{
    'applyNo': '2024051300007',
    'cityName': '基隆市',
    'created': '2024-05-14 06:50:55.120881',
    'eventName': '永續海洋環境保護',
    'id': 513,
    'location': '基隆市大武崙沙灘',
    'organizer': '基隆市天行者慈善協會',
    'participateNum': '40',
    'startTime': '05/17/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120887'
},
{
    'applyNo': '2024051000006',
    'cityName': '苗栗縣',
    'created': '2024-05-14 06:50:55.120890',
    'eventName': '白沙屯海灘守護者:沙灘淨化行動',
    'id': 514,
    'location': '苗栗縣通霄鎮白沙屯漁港',
    'organizer': '白沙屯淨鄉團',
    'participateNum': '200',
    'startTime': '06/29/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120894'
},
{
    'applyNo': '2024050900009',
    'cityName': '新北市',
    'created': '2024-05-14 06:50:55.120897',
    'eventName': '萬里淨灘活動',
    'id': 515,
    'location': '萬里螃蟹公園',
    'organizer': '救國團新北市工青二隊',
    'participateNum': '15',
    'startTime': '05/26/2024 09:00:00',
    'updated': '2024-05-14 06:50:55.120901'
}]